import { Record, Union, FSharpRef, toString } from "../Client/.fable/fable-library.3.2.1/Types.js";
import { op_UnaryNegation_Int32, parse as parse_1, tryParse } from "../Client/.fable/fable-library.3.2.1/Int32.js";
import { some, value as value_2, bind, defaultArgWith, map as map_1, defaultArg } from "../Client/.fable/fable-library.3.2.1/Option.js";
import { bool_type, array_type, unit_type, lambda_type, enum_type, class_type, list_type, record_type, option_type, tuple_type, string_type, int32_type, union_type } from "../Client/.fable/fable-library.3.2.1/Reflection.js";
import { singleton } from "../Client/.fable/fable-library.3.2.1/AsyncBuilder.js";
import { substring, join, padLeft, interpolate, toText } from "../Client/.fable/fable-library.3.2.1/String.js";
import { toString as toString_1, newGuid, parse } from "../Client/.fable/fable-library.3.2.1/Guid.js";
import { round, safeHash, getEnumerator, comparePrimitives, max, equals, int32ToString } from "../Client/.fable/fable-library.3.2.1/Util.js";
import { sumBy as sumBy_1, ofSeq, ofArray, map } from "../Client/.fable/fable-library.3.2.1/List.js";
import { FSharpResult$2 } from "../Client/.fable/fable-library.3.2.1/Choice.js";
import { now, create, year as year_1, dayOfYear, addDays, dayOfWeek as dayOfWeek_1 } from "../Client/.fable/fable-library.3.2.1/Date.js";
import { fold, append as append_1, choose, map as map_3, singleton as singleton_1, collect, delay, toArray, toList } from "../Client/.fable/fable-library.3.2.1/Seq.js";
import { rangeDouble } from "../Client/.fable/fable-library.3.2.1/Range.js";
import { sumBy, tryHead, sum, tryFind, map as map_2, append, tryFindIndex } from "../Client/.fable/fable-library.3.2.1/Array.js";
import { distinct } from "../Client/.fable/fable-library.3.2.1/Seq2.js";

export function Common_str(x) {
    let copyOfStruct = x;
    return toString(copyOfStruct);
}

export function Common_tryParseInt(str) {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(str, 511, false, 32, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return void 0;
    }
}

export function Common_parseIntOrZero(str) {
    return defaultArg(Common_tryParseInt(str), 0);
}

export class Resource$1 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["HasNotLoadedYet", "Loaded"];
    }
}

export function Resource$1$reflection(gen0) {
    return union_type("Shared.Resource`1", [gen0], Resource$1, () => [[], [["Item", gen0]]]);
}

export class Sorting extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Ascending", "Descending"];
    }
}

export function Sorting$reflection() {
    return union_type("Shared.Sorting", [], Sorting, () => [[], []]);
}

export function SortingModule_toggle(_arg1) {
    if (_arg1.tag === 1) {
        return new Sorting(0);
    }
    else {
        return new Sorting(1);
    }
}

export class PagingQuery$1 extends Record {
    constructor(Payload, Page, PageSize, SortBy) {
        super();
        this.Payload = Payload;
        this.Page = (Page | 0);
        this.PageSize = (PageSize | 0);
        this.SortBy = SortBy;
    }
}

export function PagingQuery$1$reflection(gen0) {
    return record_type("Shared.PagingQuery`1", [gen0], PagingQuery$1, () => [["Payload", gen0], ["Page", int32_type], ["PageSize", int32_type], ["SortBy", option_type(tuple_type(string_type, Sorting$reflection()))]]);
}

export class PagingResult$2 extends Record {
    constructor(Query, Page, PageSize, Total, Result) {
        super();
        this.Query = Query;
        this.Page = (Page | 0);
        this.PageSize = (PageSize | 0);
        this.Total = (Total | 0);
        this.Result = Result;
    }
}

export function PagingResult$2$reflection(gen0, gen1) {
    return record_type("Shared.PagingResult`2", [gen0, gen1], PagingResult$2, () => [["Query", gen0], ["Page", int32_type], ["PageSize", int32_type], ["Total", int32_type], ["Result", list_type(gen1)]]);
}

export function PagingResult_getAsList(query, payload) {
    return singleton.Delay(() => singleton.Bind(query(new PagingQuery$1(payload, 1, 1000, void 0)), (_arg1) => singleton.Return(_arg1.Result)));
}

export function Route_builder(typeName, methodName) {
    return toText(interpolate("/api/%s%P()/%s%P()", [typeName, methodName]));
}

export class CalendarDay_CalendarDay extends Record {
    constructor(Year, Period, Week, Day) {
        super();
        this.Year = (Year | 0);
        this.Period = (Period | 0);
        this.Week = (Week | 0);
        this.Day = (Day | 0);
    }
}

export function CalendarDay_CalendarDay$reflection() {
    return record_type("Shared.CalendarDay.CalendarDay", [], CalendarDay_CalendarDay, () => [["Year", int32_type], ["Period", int32_type], ["Week", int32_type], ["Day", int32_type]]);
}

export function UserIdModule_toString(x) {
    return x;
}

export function UserIdModule_fromString(x) {
    return parse(x);
}

export function UserIdModule_fromGuid(x) {
    return x;
}

export const UserIdModule_empty = "00000000-0000-0000-0000-000000000000";

export function EmailModule_toString(value) {
    return value;
}

export function EmailModule_ofString(s) {
    return s;
}

export function EmailModule_map(f, value) {
    return f(EmailModule_toString(value));
}

export const EmailModule_normalize = (value) => EmailModule_map((x) => x.toUpperCase(), value);

export const EmailModule_empty = EmailModule_ofString("");

export function ResetPasswordCodeModule_toString(value) {
    return value;
}

export function ResetPasswordCodeModule_ofString(x) {
    return x;
}

export const ResetPasswordCodeModule_empty = ResetPasswordCodeModule_ofString("");

export function ResetPasswordCodeModule_mkNew() {
    let copyOfStruct;
    return ResetPasswordCodeModule_ofString((copyOfStruct = newGuid(), toString_1(copyOfStruct, "N")));
}

export function PasswordHashModule_toString(value) {
    return value;
}

export function PasswordHashModule_ofString(x) {
    return x;
}

export const PasswordHashModule_empty = PasswordHashModule_ofString("");

export function NotificationIdModule_toString(x) {
    return x;
}

export function NotificationIdModule_fromString(x) {
    return x;
}

export const NotificationIdModule_empty = "";

export function NotificationIdModule_newId() {
    let copyOfStruct;
    return NotificationIdModule_fromString((copyOfStruct = newGuid(), toString_1(copyOfStruct, "N")));
}

export function GroupIdModule_toString(x) {
    return x;
}

export function GroupIdModule_fromString(x) {
    return parse(x);
}

export function GroupIdModule_fromGuid(x) {
    return x;
}

export const GroupIdModule_empty = "00000000-0000-0000-0000-000000000000";

export function SchoolIdModule_toString(x) {
    return x;
}

export function SchoolIdModule_fromString(x) {
    return parse(x);
}

export function SchoolIdModule_fromGuid(x) {
    return x;
}

export const SchoolIdModule_empty = "00000000-0000-0000-0000-000000000000";

export function StudentDayIdModule_toString(x) {
    return x;
}

export function StudentDayIdModule_fromString(x) {
    return x;
}

export function StudentDayIdModule_createStr(studentId, calendarDay) {
    return toText(interpolate("%P()-%P()-%P()-%P()-%P()", [UserIdModule_toString(studentId), calendarDay.Year, calendarDay.Period, calendarDay.Week, calendarDay.Day]));
}

export function StudentDayIdModule_create(studentId, calendarDay) {
    return StudentDayIdModule_createStr(studentId, calendarDay);
}

export const StudentDayIdModule_empty = "";

export function ScheduleIdModule_toString(x) {
    return x;
}

export function ScheduleIdModule_fromString(x) {
    return parse(x);
}

export function ScheduleIdModule_fromGuid(x) {
    return x;
}

export const ScheduleIdModule_empty = "00000000-0000-0000-0000-000000000000";

export function WorkoutIdModule_toString(x) {
    return x;
}

export function WorkoutIdModule_fromString(x) {
    return parse(x);
}

export function WorkoutIdModule_fromGuid(x) {
    return x;
}

export const WorkoutIdModule_empty = "00000000-0000-0000-0000-000000000000";

export function WorkoutTemplateIdModule_toString(x) {
    return x;
}

export function WorkoutTemplateIdModule_fromString(x) {
    return parse(x);
}

export function WorkoutTemplateIdModule_fromGuid(x) {
    return x;
}

export const WorkoutTemplateIdModule_empty = "00000000-0000-0000-0000-000000000000";

export function FavoriteIdModule_toString(x) {
    return x;
}

export function FavoriteIdModule_fromString(x) {
    return parse(x);
}

export function FavoriteIdModule_fromGuid(x) {
    return x;
}

export const FavoriteIdModule_empty = "00000000-0000-0000-0000-000000000000";

export function DurationModule_toInt(x) {
    return x;
}

export function DurationModule_fromString(x) {
    return parse_1(x, 511, false, 32);
}

export function DurationModule_fromInt(x) {
    return x;
}

export const DurationModule_empty = 0;

export function DurationModule_toHMS(x) {
    const sec = DurationModule_toInt(x) | 0;
    return [~(~(sec / 3600)), (~(~(sec / 60))) % 60, sec % 60];
}

export function DurationModule_toHMSString(x) {
    const patternInput = DurationModule_toHMS(x);
    return (int32ToString(patternInput[0]) + ":") + padLeft(int32ToString(patternInput[1]), 2, "0");
}

export function DurationModule_intToHMSString(x) {
    return DurationModule_toHMSString(DurationModule_fromInt(x));
}

export class Errors_ValidationErrorType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EmptyChangePasswordId", "FieldChangePasswordIdIsNone"];
    }
}

export function Errors_ValidationErrorType$reflection() {
    return union_type("Shared.Errors.ValidationErrorType", [], Errors_ValidationErrorType, () => [[["Item", class_type("System.Guid")]], []]);
}

export class Errors_ValidationError extends Record {
    constructor(Field, Type) {
        super();
        this.Field = Field;
        this.Type = Type;
    }
}

export function Errors_ValidationError$reflection() {
    return record_type("Shared.Errors.ValidationError", [], Errors_ValidationError, () => [["Field", string_type], ["Type", Errors_ValidationErrorType$reflection()]]);
}

export class Errors_DomainError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AccountEmailNotExist", "AccountEmailAlreadyRegistered", "PasswordAndConfirmationAreDifferent", "PasswordOrUserInvalid", "ChangePasswordIdIsNone", "AccountChangePasswordIdNotExist"];
    }
}

export function Errors_DomainError$reflection() {
    return union_type("Shared.Errors.DomainError", [], Errors_DomainError, () => [[["Item", string_type]], [["Item", string_type]], [], [], [], [["Item", string_type]]]);
}

export class Errors_ServiceInfo extends Record {
    constructor(Name, Endpoint) {
        super();
        this.Name = Name;
        this.Endpoint = Endpoint;
    }
}

export function Errors_ServiceInfo$reflection() {
    return record_type("Shared.Errors.ServiceInfo", [], Errors_ServiceInfo, () => [["Name", string_type], ["Endpoint", string_type]]);
}

export class Errors_RemoteServiceError extends Record {
    constructor(Service, Errors) {
        super();
        this.Service = Service;
        this.Errors = Errors;
    }
}

export function Errors_RemoteServiceError$reflection() {
    return record_type("Shared.Errors.RemoteServiceError", [], Errors_RemoteServiceError, () => [["Service", Errors_ServiceInfo$reflection()], ["Errors", list_type(string_type)]]);
}

export function Errors_RemoteServiceErrorModule_create(serviceName, endpoint, errors) {
    return new Errors_RemoteServiceError(new Errors_ServiceInfo(serviceName, endpoint), errors);
}

export class Errors_ServerError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Exception", "Validation", "DatabaseItemNotFound", "Domain", "RemoteServiceError"];
    }
}

export function Errors_ServerError$reflection() {
    return union_type("Shared.Errors.ServerError", [], Errors_ServerError, () => [[["Item", string_type]], [["Item", list_type(Errors_ValidationError$reflection())]], [["Item", string_type]], [["Item", Errors_DomainError$reflection()]], [["Item", Errors_RemoteServiceError$reflection()]]]);
}

export function Errors_DomainErrorModule_explain(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return toText(interpolate("Account with email \u0027%s%P()\u0027 already registered", [_arg1.fields[0]]));
        }
        case 2: {
            return "Password and password confirmation are different";
        }
        case 3: {
            return "Invalid user or password";
        }
        case 4: {
            return "Id for changing password was not found in database";
        }
        case 5: {
            return toText(interpolate("Account with this id for changing password %A%P() doesn\u0027t exist", [_arg1.fields[0]]));
        }
        default: {
            return toText(interpolate("Account with email \u0027%s%P()\u0027 doesn\u0027t exist", [_arg1.fields[0]]));
        }
    }
}

export function Errors_ValidationErrorModule_create(fieldName, error) {
    return new Errors_ValidationError(fieldName, error);
}

export function Errors_ValidationErrorModule_explainType(_arg1) {
    if (_arg1.tag === 1) {
        return "Change password Id wasn\u0027t created";
    }
    else {
        return toText(interpolate("Change password Id is empty %A%P()", [_arg1.fields[0]]));
    }
}

export function Errors_ValidationErrorModule_explain(error) {
    return toText(interpolate("Field \u0027%s%P()\u0027 %s%P()", [error.Field, Errors_ValidationErrorModule_explainType(error.Type)]));
}

export function Errors_ServerErrorModule_explain(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return join(", ", map((error) => Errors_ValidationErrorModule_explain(error), _arg1.fields[0]));
        }
        case 2: {
            return "Not found in database";
        }
        case 3: {
            return Errors_DomainErrorModule_explain(_arg1.fields[0]);
        }
        case 4: {
            return "Problem with third party services";
        }
        default: {
            return toText(interpolate("Ops, something wrong happened. Details: %s%P()", [_arg1.fields[0]]));
        }
    }
}

export function ChangePasswordId_create(changePasswordId) {
    if (changePasswordId == null) {
        return new FSharpResult$2(1, Errors_ValidationErrorModule_create("ChangePasswordIdId", new Errors_ValidationErrorType(1)));
    }
    else {
        const passwordId = changePasswordId;
        if (passwordId === "00000000-0000-0000-0000-000000000000") {
            return new FSharpResult$2(1, Errors_ValidationErrorModule_create("changePasswordId", new Errors_ValidationErrorType(0, passwordId)));
        }
        else {
            return new FSharpResult$2(0, passwordId);
        }
    }
}

export class Auth_SignedInUser extends Record {
    constructor(Email, FullName, SchoolId, GroupId, GdprAcceptDate, AccessToken, Role, UserId, ChatText, ChatChangeDate) {
        super();
        this.Email = Email;
        this.FullName = FullName;
        this.SchoolId = SchoolId;
        this.GroupId = GroupId;
        this.GdprAcceptDate = GdprAcceptDate;
        this.AccessToken = AccessToken;
        this.Role = (Role | 0);
        this.UserId = UserId;
        this.ChatText = ChatText;
        this.ChatChangeDate = ChatChangeDate;
    }
}

export function Auth_SignedInUser$reflection() {
    return record_type("Shared.Auth.SignedInUser", [], Auth_SignedInUser, () => [["Email", string_type], ["FullName", string_type], ["SchoolId", option_type(class_type("System.Guid"))], ["GroupId", option_type(class_type("System.Guid"))], ["GdprAcceptDate", option_type(class_type("System.DateTimeOffset"))], ["AccessToken", string_type], ["Role", enum_type("Shared.Auth.UserRole", int32_type, [["Admin", 1], ["Teacher", 2], ["Student", 3]])], ["UserId", class_type("System.Guid")], ["ChatText", string_type], ["ChatChangeDate", option_type(class_type("System.DateTimeOffset"))]]);
}

export class Auth_LogInRequest extends Record {
    constructor(Email, Password) {
        super();
        this.Email = Email;
        this.Password = Password;
    }
}

export function Auth_LogInRequest$reflection() {
    return record_type("Shared.Auth.LogInRequest", [], Auth_LogInRequest, () => [["Email", string_type], ["Password", string_type]]);
}

export class Auth_VerifyActivationCodeResult extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Valid", "Invalid", "AlreadyActivated"];
    }
}

export function Auth_VerifyActivationCodeResult$reflection() {
    return union_type("Shared.Auth.VerifyActivationCodeResult", [], Auth_VerifyActivationCodeResult, () => [[], [], []]);
}

export class Auth_SignInApi extends Record {
    constructor(logIn, logOut) {
        super();
        this.logIn = logIn;
        this.logOut = logOut;
    }
}

export function Auth_SignInApi$reflection() {
    return record_type("Shared.Auth.SignInApi", [], Auth_SignInApi, () => [["logIn", lambda_type(Auth_LogInRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Auth_SignedInUser$reflection(), Errors_ServerError$reflection()], FSharpResult$2, () => [[["ResultValue", Auth_SignedInUser$reflection()]], [["ErrorValue", Errors_ServerError$reflection()]]])]))], ["logOut", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))]]);
}

export class Users_User extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Anonymous", "Logged"];
    }
}

export function Users_User$reflection() {
    return union_type("Shared.Users.User", [], Users_User, () => [[], [["Item", Auth_SignedInUser$reflection()]]]);
}

export class Users_RegisteredUser extends Record {
    constructor(Id, Email, FullName, DeletedDate) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.FullName = FullName;
        this.DeletedDate = DeletedDate;
    }
}

export function Users_RegisteredUser$reflection() {
    return record_type("Shared.Users.RegisteredUser", [], Users_RegisteredUser, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["FullName", string_type], ["DeletedDate", option_type(class_type("System.DateTimeOffset"))]]);
}

export class Users_ResetPasswordRequest extends Record {
    constructor(Code, Password) {
        super();
        this.Code = Code;
        this.Password = Password;
    }
}

export function Users_ResetPasswordRequest$reflection() {
    return record_type("Shared.Users.ResetPasswordRequest", [], Users_ResetPasswordRequest, () => [["Code", string_type], ["Password", string_type]]);
}

export class Users_RegisterUserError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AccountAlreadyRegistered"];
    }
}

export function Users_RegisterUserError$reflection() {
    return union_type("Shared.Users.RegisterUserError", [], Users_RegisterUserError, () => [[["Item", string_type]]]);
}

export class Users_RequestResetPasswordError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AccountWithGivenEmailDoesNotExists"];
    }
}

export function Users_RequestResetPasswordError$reflection() {
    return union_type("Shared.Users.RequestResetPasswordError", [], Users_RequestResetPasswordError, () => [[["Item", string_type]]]);
}

export class Users_ResetPasswordError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CodeIsInvalid"];
    }
}

export function Users_ResetPasswordError$reflection() {
    return union_type("Shared.Users.ResetPasswordError", [], Users_ResetPasswordError, () => [[["Item", string_type]]]);
}

export class Users_UsersApi extends Record {
    constructor(requestResetPassword, resetPassword, getUser, restore) {
        super();
        this.requestResetPassword = requestResetPassword;
        this.resetPassword = resetPassword;
        this.getUser = getUser;
        this.restore = restore;
    }
}

export function Users_UsersApi$reflection() {
    return record_type("Shared.Users.UsersApi", [], Users_UsersApi, () => [["requestResetPassword", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, Users_RequestResetPasswordError$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", Users_RequestResetPasswordError$reflection()]]])]))], ["resetPassword", lambda_type(Users_ResetPasswordRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Users_ResetPasswordError$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Users_ResetPasswordError$reflection()]]])]))], ["getUser", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [option_type(Users_RegisteredUser$reflection())]))], ["restore", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))]]);
}

export function Users_UserModule_toOption(_arg1) {
    if (_arg1.tag === 1) {
        return _arg1.fields[0];
    }
    else {
        return void 0;
    }
}

export const Users_UserModule_userId = (arg) => map_1((x) => x.UserId, Users_UserModule_toOption(arg));

export function Users_UserModule_isAnonymous(user) {
    return equals(user, new Users_User(0));
}

export class Settings_ChangeEmail extends Record {
    constructor(Email) {
        super();
        this.Email = Email;
    }
}

export function Settings_ChangeEmail$reflection() {
    return record_type("Shared.Settings.ChangeEmail", [], Settings_ChangeEmail, () => [["Email", string_type]]);
}

export class Settings_ChangeEmailError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AccountDoesNotExists"];
    }
}

export function Settings_ChangeEmailError$reflection() {
    return union_type("Shared.Settings.ChangeEmailError", [], Settings_ChangeEmailError, () => [[]]);
}

export class Settings_ChangeFullName extends Record {
    constructor(FullName) {
        super();
        this.FullName = FullName;
    }
}

export function Settings_ChangeFullName$reflection() {
    return record_type("Shared.Settings.ChangeFullName", [], Settings_ChangeFullName, () => [["FullName", string_type]]);
}

export class Settings_ChangeFullNameError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AccountDoesNotExists"];
    }
}

export function Settings_ChangeFullNameError$reflection() {
    return union_type("Shared.Settings.ChangeFullNameError", [], Settings_ChangeFullNameError, () => [[]]);
}

export class Settings_ChangePassword extends Record {
    constructor(CurrentPassword, NewPassword) {
        super();
        this.CurrentPassword = CurrentPassword;
        this.NewPassword = NewPassword;
    }
}

export function Settings_ChangePassword$reflection() {
    return record_type("Shared.Settings.ChangePassword", [], Settings_ChangePassword, () => [["CurrentPassword", string_type], ["NewPassword", string_type]]);
}

export class Settings_ChangePasswordError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AccountDoesNotExists", "InvalidPassword"];
    }
}

export function Settings_ChangePasswordError$reflection() {
    return union_type("Shared.Settings.ChangePasswordError", [], Settings_ChangePasswordError, () => [[], []]);
}

export class Settings_AcceptGdprError extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AccountDoesNotExists"];
    }
}

export function Settings_AcceptGdprError$reflection() {
    return union_type("Shared.Settings.AcceptGdprError", [], Settings_AcceptGdprError, () => [[]]);
}

export class Settings_SettingsApi extends Record {
    constructor(changeEmail, changeFullName, changePassword, acceptGdpr) {
        super();
        this.changeEmail = changeEmail;
        this.changeFullName = changeFullName;
        this.changePassword = changePassword;
        this.acceptGdpr = acceptGdpr;
    }
}

export function Settings_SettingsApi$reflection() {
    return record_type("Shared.Settings.SettingsApi", [], Settings_SettingsApi, () => [["changeEmail", lambda_type(Settings_ChangeEmail$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Settings_ChangeEmailError$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Settings_ChangeEmailError$reflection()]]])]))], ["changeFullName", lambda_type(Settings_ChangeFullName$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Settings_ChangeFullNameError$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Settings_ChangeFullNameError$reflection()]]])]))], ["changePassword", lambda_type(Settings_ChangePassword$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Settings_ChangePasswordError$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Settings_ChangePasswordError$reflection()]]])]))], ["acceptGdpr", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Settings_AcceptGdprError$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Settings_AcceptGdprError$reflection()]]])]))]]);
}

export const Calendar_startWeek = 17;

export class Calendar_YearWeek extends Record {
    constructor(Year, Week) {
        super();
        this.Year = (Year | 0);
        this.Week = (Week | 0);
    }
}

export function Calendar_YearWeek$reflection() {
    return record_type("Shared.Calendar.YearWeek", [], Calendar_YearWeek, () => [["Year", int32_type], ["Week", int32_type]]);
}

export function Calendar_getWeekDayIndex0Based(date) {
    const dayOfWeek = dayOfWeek_1(date) | 0;
    if (dayOfWeek === 0) {
        return 6;
    }
    else {
        return (dayOfWeek - 1) | 0;
    }
}

export function Calendar_getWeekDayDate(date, weekDay0Based) {
    return addDays(date, (-Calendar_getWeekDayIndex0Based(date)) + weekDay0Based);
}

export function Calendar_getWeekOfYear(date) {
    const dateThursday = Calendar_getWeekDayDate(date, 3);
    const week = (~(~Math.ceil(dayOfYear(dateThursday) / 7))) | 0;
    return new Calendar_YearWeek(year_1(dateThursday), week);
}

export function Calendar_getYearWeeksCount(year) {
    return max((x, y) => comparePrimitives(x, y), Calendar_getWeekOfYear(create(year, 12, 25)).Week, Calendar_getWeekOfYear(create(year, 12, 31)).Week);
}

export const Calendar_yearPeriodsRange = toList(rangeDouble(0, 1, 12));

export const Calendar_periodWeeksRange = toList(rangeDouble(0, 1, 3));

export const Calendar_weekDaysRange = toList(rangeDouble(0, 1, 6));

export class Calendar_PeriodInfo extends Record {
    constructor(PeriodYear, Period) {
        super();
        this.PeriodYear = (PeriodYear | 0);
        this.Period = (Period | 0);
    }
}

export function Calendar_PeriodInfo$reflection() {
    return record_type("Shared.Calendar.PeriodInfo", [], Calendar_PeriodInfo, () => [["PeriodYear", int32_type], ["Period", int32_type]]);
}

export function Calendar_PeriodInfo__Previous(this$) {
    if (this$.Period === 0) {
        return new Calendar_PeriodInfo(this$.PeriodYear - 1, 12);
    }
    else {
        return new Calendar_PeriodInfo(this$.PeriodYear, this$.Period - 1);
    }
}

export function Calendar_PeriodInfo__PreviousN_Z524259A4(this$, n) {
    let period = this$;
    const enumerator = getEnumerator(toList(rangeDouble(1, 1, n)));
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
            period = Calendar_PeriodInfo__Previous(period);
        }
    }
    finally {
        enumerator.Dispose();
    }
    return period;
}

export function Calendar_PeriodInfo__Next(this$) {
    if (this$.Period >= 12) {
        return new Calendar_PeriodInfo(this$.PeriodYear + 1, 0);
    }
    else {
        return new Calendar_PeriodInfo(this$.PeriodYear, this$.Period + 1);
    }
}

export function Calendar_PeriodInfo__NextN_Z524259A4(this$, n) {
    let period = this$;
    const enumerator = getEnumerator(toList(rangeDouble(1, 1, n)));
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
            period = Calendar_PeriodInfo__Next(period);
        }
    }
    finally {
        enumerator.Dispose();
    }
    return period;
}

export function Calendar_PeriodInfo__ShiftN_Z524259A4(this$, periodShift) {
    if (periodShift < 0) {
        return Calendar_PeriodInfo__PreviousN_Z524259A4(this$, op_UnaryNegation_Int32(periodShift));
    }
    else {
        return Calendar_PeriodInfo__NextN_Z524259A4(this$, periodShift);
    }
}

export class Calendar_Period13Behavior extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["LeavePeriod13AsItIs", "HandlePeriod13AsPrevYearLastWeek", "HandlePeriod13AsNextYearFirstWeek"];
    }
}

export function Calendar_Period13Behavior$reflection() {
    return union_type("Shared.Calendar.Period13Behavior", [], Calendar_Period13Behavior, () => [[], [], []]);
}

export class Calendar_WeekInfo extends Record {
    constructor(PeriodInfo, PeriodWeek) {
        super();
        this.PeriodInfo = PeriodInfo;
        this.PeriodWeek = (PeriodWeek | 0);
    }
}

export function Calendar_WeekInfo$reflection() {
    return record_type("Shared.Calendar.WeekInfo", [], Calendar_WeekInfo, () => [["PeriodInfo", Calendar_PeriodInfo$reflection()], ["PeriodWeek", int32_type]]);
}

export function Calendar_WeekInfo_FromDate(date, period13Behavior) {
    const weekInfoCurrent = Calendar_getWeekOfYear(date);
    const weekCurrent = weekInfoCurrent.Week | 0;
    let weekInfoFromStartWeek;
    if (weekCurrent < Calendar_startWeek) {
        const prevYear = (weekInfoCurrent.Year - 1) | 0;
        weekInfoFromStartWeek = (new Calendar_YearWeek(prevYear, weekCurrent + Calendar_getYearWeeksCount(prevYear)));
    }
    else {
        weekInfoFromStartWeek = weekInfoCurrent;
    }
    const weekFromStart = (weekInfoFromStartWeek.Week - Calendar_startWeek) | 0;
    const year = weekInfoFromStartWeek.Year | 0;
    const period = (~(~(weekFromStart / 4))) | 0;
    const weekInfo = new Calendar_WeekInfo(new Calendar_PeriodInfo(year, period), weekFromStart - (period * 4));
    if (weekInfo.PeriodInfo.Period !== 13) {
        return weekInfo;
    }
    else {
        switch (period13Behavior.tag) {
            case 1: {
                return new Calendar_WeekInfo(new Calendar_PeriodInfo(year, 12), 3);
            }
            case 2: {
                return new Calendar_WeekInfo(new Calendar_PeriodInfo(year + 1, 0), 0);
            }
            default: {
                return weekInfo;
            }
        }
    }
}

export function Calendar_WeekInfo_get_Current() {
    return Calendar_WeekInfo_FromDate(now(), new Calendar_Period13Behavior(2));
}

export function Calendar_WeekInfo__Next(this$) {
    if (this$.PeriodWeek >= 3) {
        return new Calendar_WeekInfo(Calendar_PeriodInfo__Next(this$.PeriodInfo), 0);
    }
    else {
        return new Calendar_WeekInfo(this$.PeriodInfo, this$.PeriodWeek + 1);
    }
}

export function Calendar_WeekInfo__NextN_Z524259A4(this$, n) {
    let week = this$;
    const enumerator = getEnumerator(toList(rangeDouble(1, 1, n)));
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
            week = Calendar_WeekInfo__Next(week);
        }
    }
    finally {
        enumerator.Dispose();
    }
    return week;
}

export function Calendar_WeekInfo__Previous(this$) {
    if (this$.PeriodWeek === 0) {
        return new Calendar_WeekInfo(Calendar_PeriodInfo__Previous(this$.PeriodInfo), 3);
    }
    else {
        return new Calendar_WeekInfo(this$.PeriodInfo, this$.PeriodWeek - 1);
    }
}

export function Calendar_PeriodInfo_FromDate_7F9DDECF(date) {
    return Calendar_WeekInfo_FromDate(date, new Calendar_Period13Behavior(2)).PeriodInfo;
}

export function Calendar_PeriodInfo_get_Current() {
    return Calendar_PeriodInfo_FromDate_7F9DDECF(now());
}

export function Calendar_getYearWeekIndex(weekInfo) {
    const yearWeeksCount = Calendar_getYearWeeksCount(weekInfo.PeriodInfo.PeriodYear) | 0;
    const yearWeekIndex = ((Calendar_startWeek + (weekInfo.PeriodInfo.Period * 4)) + weekInfo.PeriodWeek) | 0;
    if (yearWeekIndex > yearWeeksCount) {
        return (yearWeekIndex - yearWeeksCount) | 0;
    }
    else {
        return yearWeekIndex | 0;
    }
}

export function Calendar_getPeriodInfo(periodYear, period) {
    return new Calendar_PeriodInfo(periodYear, period);
}

export function Calendar_getWeekInfo(periodInfo, periodWeek) {
    return new Calendar_WeekInfo(periodInfo, periodWeek);
}

export function Calendar_getWeekInfoYPW(periodYear, period, periodWeek) {
    return new Calendar_WeekInfo(Calendar_getPeriodInfo(periodYear, period), periodWeek);
}

export function Calendar_isBiggerWeekInfo(left, right) {
    return (((left.PeriodInfo.PeriodYear * 53) + (left.PeriodInfo.Period * 4)) + left.PeriodWeek) > (((right.PeriodInfo.PeriodYear * 53) + (right.PeriodInfo.Period * 4)) + right.PeriodWeek);
}

export function Calendar_isNotBiggerWeekInfo(left, right) {
    return !Calendar_isBiggerWeekInfo(left, right);
}

export function Calendar_getWeekStartDate(weekInfo) {
    const weekIndex = (((Calendar_startWeek - 1) + (weekInfo.PeriodInfo.Period * 4)) + weekInfo.PeriodWeek) | 0;
    let weekStartDate = Calendar_getWeekDayDate(addDays(create(weekInfo.PeriodInfo.PeriodYear, 1, 1), weekIndex * 7), 0);
    let weekStartDateWeekInfo = Calendar_WeekInfo_FromDate(weekStartDate, new Calendar_Period13Behavior(2));
    while (Calendar_isBiggerWeekInfo(weekInfo, weekStartDateWeekInfo)) {
        weekStartDate = addDays(weekStartDate, 7);
        weekStartDateWeekInfo = Calendar_WeekInfo_FromDate(weekStartDate, new Calendar_Period13Behavior(2));
    }
    return weekStartDate;
}

export function Calendar_getWeekEndDate(weekInfo) {
    let copyOfStruct = Calendar_getWeekStartDate(weekInfo);
    return addDays(copyOfStruct, 6);
}

export function Calendar_getPeriodStartDate(periodInfo) {
    return Calendar_getWeekStartDate(Calendar_getWeekInfo(periodInfo, 0));
}

export function Calendar_getPeriodEndDate(periodInfo) {
    return Calendar_getWeekEndDate(Calendar_getWeekInfo(periodInfo, 3));
}

export function Calendar_getYearStartDate(year) {
    return Calendar_getWeekStartDate(Calendar_getWeekInfoYPW(year, 0, 0));
}

export function Calendar_getYearEndDate(year) {
    return Calendar_getWeekEndDate(Calendar_getWeekInfoYPW(year, 12, 3));
}

export function Calendar_getDayDate(weekInfo, weekDay) {
    return addDays(Calendar_getWeekStartDate(weekInfo), weekDay);
}

export function Calendar_getMonthTitle(month1Based) {
    switch (month1Based) {
        case 1: {
            return "Januari";
        }
        case 2: {
            return "Februari";
        }
        case 3: {
            return "Mars";
        }
        case 4: {
            return "April";
        }
        case 5: {
            return "Maj";
        }
        case 6: {
            return "Juni";
        }
        case 7: {
            return "Juli";
        }
        case 8: {
            return "Augusti";
        }
        case 9: {
            return "September";
        }
        case 10: {
            return "Oktober";
        }
        case 11: {
            return "November";
        }
        case 12: {
            return "December";
        }
        default: {
            return void 0;
        }
    }
}

export function Calendar_getMonth3LetterTitle(month1Based) {
    return map_1((x) => substring(x, 0, 3), Calendar_getMonthTitle(month1Based));
}

export function Calendar_getWeekDayTitle(weekDay0Based) {
    switch (weekDay0Based) {
        case 0: {
            return "Måndag";
        }
        case 1: {
            return "Tisdag";
        }
        case 2: {
            return "Onsdag";
        }
        case 3: {
            return "Torsdag";
        }
        case 4: {
            return "Fredag";
        }
        case 5: {
            return "Lördag";
        }
        case 6: {
            return "Söndag";
        }
        default: {
            return void 0;
        }
    }
}

export function Calendar_getWeekDay3LetterTitle(weekDay0Based) {
    return map_1((x) => substring(x, 0, 3), Calendar_getWeekDayTitle(weekDay0Based));
}

export class Calendar_DayInfo extends Record {
    constructor(WeekInfo, WeekDay) {
        super();
        this.WeekInfo = WeekInfo;
        this.WeekDay = (WeekDay | 0);
    }
}

export function Calendar_DayInfo$reflection() {
    return record_type("Shared.Calendar.DayInfo", [], Calendar_DayInfo, () => [["WeekInfo", Calendar_WeekInfo$reflection()], ["WeekDay", int32_type]]);
}

export function Calendar_DayInfo_FromDate_7F9DDECF(date) {
    return new Calendar_DayInfo(Calendar_WeekInfo_FromDate(date, new Calendar_Period13Behavior(2)), Calendar_getWeekDayIndex0Based(date));
}

export function Calendar_DayInfo_get_Current() {
    return Calendar_DayInfo_FromDate_7F9DDECF(now());
}

export function Calendar_getCalendarDayFromWeekInfo(weekInfo, weekDay) {
    return new CalendarDay_CalendarDay(weekInfo.PeriodInfo.PeriodYear, weekInfo.PeriodInfo.Period, weekInfo.PeriodWeek, weekDay);
}

export function Calendar_getCalendarDayFromDayInfo(dayInfo) {
    return Calendar_getCalendarDayFromWeekInfo(dayInfo.WeekInfo, dayInfo.WeekDay);
}

export function Calendar_getCalendarDayFromDate(date) {
    return Calendar_getCalendarDayFromDayInfo(Calendar_DayInfo_FromDate_7F9DDECF(date));
}

export function Calendar_getCalendarDayDate(calendarDay) {
    return Calendar_getDayDate(Calendar_getWeekInfo(Calendar_getPeriodInfo(calendarDay.Year, calendarDay.Period), calendarDay.Week), calendarDay.Day);
}

export function Shared_CalendarDay_CalendarDay__CalendarDay_PeriodInfo(this$) {
    return new Calendar_PeriodInfo(this$.Year, this$.Period);
}

export function Shared_CalendarDay_CalendarDay__CalendarDay_WeekInfo(this$) {
    return new Calendar_WeekInfo(Shared_CalendarDay_CalendarDay__CalendarDay_PeriodInfo(this$), this$.Week);
}

export class Plans_PeriodPlan extends Record {
    constructor(TotalHours, WeekHours) {
        super();
        this.TotalHours = (TotalHours | 0);
        this.WeekHours = WeekHours;
    }
}

export function Plans_PeriodPlan$reflection() {
    return record_type("Shared.Plans.PeriodPlan", [], Plans_PeriodPlan, () => [["TotalHours", int32_type], ["WeekHours", array_type(int32_type)]]);
}

export function Plans_PeriodPlan_Create(totalHours, weekHours) {
    return new Plans_PeriodPlan(totalHours, weekHours);
}

export class Plans_YearPlan extends Record {
    constructor(Year, TotalHours, PeriodPlans) {
        super();
        this.Year = (Year | 0);
        this.TotalHours = (TotalHours | 0);
        this.PeriodPlans = PeriodPlans;
    }
}

export function Plans_YearPlan$reflection() {
    return record_type("Shared.Plans.YearPlan", [], Plans_YearPlan, () => [["Year", int32_type], ["TotalHours", int32_type], ["PeriodPlans", array_type(Plans_PeriodPlan$reflection())]]);
}

export function Plans_YearPlan_Default_4019FA9(year) {
    return new Plans_YearPlan(defaultArgWith(year, () => Calendar_WeekInfo_get_Current().PeriodInfo.PeriodYear), 0, toArray(delay(() => collect((matchValue) => singleton_1(new Plans_PeriodPlan(0, new Int32Array([0, 0, 0, 0]))), rangeDouble(0, 1, 12)))));
}

export function Plans_YearPlan_AddOrUpdateYearPlan(yearPlan, yearPlans) {
    const index = tryFindIndex((plan) => (plan.Year === yearPlan.Year), yearPlans);
    if (index == null) {
        return append(yearPlans, [yearPlan]);
    }
    else {
        return map_2((plan_1) => ((plan_1.Year === yearPlan.Year) ? yearPlan : plan_1), yearPlans);
    }
}

export class Groups_GroupCreateRequest extends Record {
    constructor(Id, Title, YearPlan) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.YearPlan = YearPlan;
    }
}

export function Groups_GroupCreateRequest$reflection() {
    return record_type("Shared.Groups.GroupCreateRequest", [], Groups_GroupCreateRequest, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["YearPlan", Plans_YearPlan$reflection()]]);
}

export class Groups_GroupUpdateRequest extends Record {
    constructor(Id, Title, YearPlan) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.YearPlan = YearPlan;
    }
}

export function Groups_GroupUpdateRequest$reflection() {
    return record_type("Shared.Groups.GroupUpdateRequest", [], Groups_GroupUpdateRequest, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["YearPlan", Plans_YearPlan$reflection()]]);
}

export class Groups_Group extends Record {
    constructor(Id, Title, YearPlans) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.YearPlans = YearPlans;
    }
}

export function Groups_Group$reflection() {
    return record_type("Shared.Groups.Group", [], Groups_Group, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["YearPlans", array_type(Plans_YearPlan$reflection())]]);
}

export function Groups_Group_Default_4019FA9(year) {
    return new Groups_Group(GroupIdModule_fromGuid(newGuid()), "New group", [Plans_YearPlan_Default_4019FA9(year)]);
}

export function Groups_getYearPlanOrDefault(plans, year) {
    return defaultArg(tryFind((x) => (x.Year === year), plans), Plans_YearPlan_Default_4019FA9(year));
}

export class Groups_GroupListItem extends Record {
    constructor(Id, Title) {
        super();
        this.Id = Id;
        this.Title = Title;
    }
}

export function Groups_GroupListItem$reflection() {
    return record_type("Shared.Groups.GroupListItem", [], Groups_GroupListItem, () => [["Id", class_type("System.Guid")], ["Title", string_type]]);
}

export class Groups_GroupsOrderUpdateRequest extends Record {
    constructor(GroupIds) {
        super();
        this.GroupIds = GroupIds;
    }
}

export function Groups_GroupsOrderUpdateRequest$reflection() {
    return record_type("Shared.Groups.GroupsOrderUpdateRequest", [], Groups_GroupsOrderUpdateRequest, () => [["GroupIds", array_type(class_type("System.Guid"))]]);
}

export class Groups_GroupsApi extends Record {
    constructor(list, get$, create, update, delete$, getGroupsOrder, updateGroupsOrder) {
        super();
        this.list = list;
        this.get = get$;
        this.create = create;
        this.update = update;
        this.delete = delete$;
        this.getGroupsOrder = getGroupsOrder;
        this.updateGroupsOrder = updateGroupsOrder;
    }
}

export function Groups_GroupsApi$reflection() {
    return record_type("Shared.Groups.GroupsApi", [], Groups_GroupsApi, () => [["list", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Groups_GroupListItem$reflection())]))], ["get", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [Groups_Group$reflection()]))], ["create", lambda_type(Groups_GroupCreateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["update", lambda_type(Groups_GroupUpdateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["delete", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["getGroupsOrder", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(class_type("System.Guid"))]))], ["updateGroupsOrder", lambda_type(Groups_GroupsOrderUpdateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))]]);
}

export class Students_StudentSettings extends Record {
    constructor(Id, Email, FullName, GroupId, ChatText, ChatChangeDate) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.FullName = FullName;
        this.GroupId = GroupId;
        this.ChatText = ChatText;
        this.ChatChangeDate = ChatChangeDate;
    }
}

export function Students_StudentSettings$reflection() {
    return record_type("Shared.Students.StudentSettings", [], Students_StudentSettings, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["FullName", string_type], ["GroupId", class_type("System.Guid")], ["ChatText", string_type], ["ChatChangeDate", option_type(class_type("System.DateTimeOffset"))]]);
}

export function Students_StudentSettings_Default_Z3CDDBBFA(groupId) {
    return new Students_StudentSettings(UserIdModule_fromGuid(newGuid()), EmailModule_empty, "New user", groupId, "", void 0);
}

export class Students_StudentPlans extends Record {
    constructor(Id, YearPlans) {
        super();
        this.Id = Id;
        this.YearPlans = YearPlans;
    }
}

export function Students_StudentPlans$reflection() {
    return record_type("Shared.Students.StudentPlans", [], Students_StudentPlans, () => [["Id", class_type("System.Guid")], ["YearPlans", array_type(Plans_YearPlan$reflection())]]);
}

export function Students_getYearPlanOrGroupOrDefault(studentPlans, groupPlans, year) {
    return defaultArg(defaultArg(tryFind((x) => (x.Year === year), studentPlans), tryFind((x_1) => (x_1.Year === year), groupPlans)), Plans_YearPlan_Default_4019FA9(year));
}

export class Students_StudentCreateRequest extends Record {
    constructor(Id, Email, Password, FullName, GroupId) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.Password = Password;
        this.FullName = FullName;
        this.GroupId = GroupId;
    }
}

export function Students_StudentCreateRequest$reflection() {
    return record_type("Shared.Students.StudentCreateRequest", [], Students_StudentCreateRequest, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["Password", string_type], ["FullName", string_type], ["GroupId", class_type("System.Guid")]]);
}

export class Students_StudentUpdateSettingsRequest extends Record {
    constructor(Id, Email, Password, FullName, GroupId) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.Password = Password;
        this.FullName = FullName;
        this.GroupId = GroupId;
    }
}

export function Students_StudentUpdateSettingsRequest$reflection() {
    return record_type("Shared.Students.StudentUpdateSettingsRequest", [], Students_StudentUpdateSettingsRequest, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["Password", string_type], ["FullName", string_type], ["GroupId", class_type("System.Guid")]]);
}

export class Students_StudentUpdatePlanRequest extends Record {
    constructor(Id, YearPlan) {
        super();
        this.Id = Id;
        this.YearPlan = YearPlan;
    }
}

export function Students_StudentUpdatePlanRequest$reflection() {
    return record_type("Shared.Students.StudentUpdatePlanRequest", [], Students_StudentUpdatePlanRequest, () => [["Id", class_type("System.Guid")], ["YearPlan", Plans_YearPlan$reflection()]]);
}

export class Students_StudentUpdateChatTextRequest extends Record {
    constructor(Id, ChatText) {
        super();
        this.Id = Id;
        this.ChatText = ChatText;
    }
}

export function Students_StudentUpdateChatTextRequest$reflection() {
    return record_type("Shared.Students.StudentUpdateChatTextRequest", [], Students_StudentUpdateChatTextRequest, () => [["Id", class_type("System.Guid")], ["ChatText", string_type]]);
}

export class Students_StudentListItem extends Record {
    constructor(Id, Email, FullName, GroupId, SchoolId, ChatChangeDate) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.FullName = FullName;
        this.GroupId = GroupId;
        this.SchoolId = SchoolId;
        this.ChatChangeDate = ChatChangeDate;
    }
}

export function Students_StudentListItem$reflection() {
    return record_type("Shared.Students.StudentListItem", [], Students_StudentListItem, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["FullName", string_type], ["GroupId", class_type("System.Guid")], ["SchoolId", class_type("System.Guid")], ["ChatChangeDate", option_type(class_type("System.DateTimeOffset"))]]);
}

export class Students_TeacherListItem extends Record {
    constructor(Id, Email, FullName, SchoolId) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.FullName = FullName;
        this.SchoolId = SchoolId;
    }
}

export function Students_TeacherListItem$reflection() {
    return record_type("Shared.Students.TeacherListItem", [], Students_TeacherListItem, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["FullName", string_type], ["SchoolId", class_type("System.Guid")]]);
}

export class Students_StudentsApi extends Record {
    constructor(list, getSettings, getPlans, create, updateSettings, updatePlan, updateChatText, delete$, getStudentExternalTeachers, listExternalStudents, addExternalTeacher, deleteExternalTeacher) {
        super();
        this.list = list;
        this.getSettings = getSettings;
        this.getPlans = getPlans;
        this.create = create;
        this.updateSettings = updateSettings;
        this.updatePlan = updatePlan;
        this.updateChatText = updateChatText;
        this.delete = delete$;
        this.getStudentExternalTeachers = getStudentExternalTeachers;
        this.listExternalStudents = listExternalStudents;
        this.addExternalTeacher = addExternalTeacher;
        this.deleteExternalTeacher = deleteExternalTeacher;
    }
}

export function Students_StudentsApi$reflection() {
    return record_type("Shared.Students.StudentsApi", [], Students_StudentsApi, () => [["list", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Students_StudentListItem$reflection())]))], ["getSettings", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Students_StudentSettings$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", Students_StudentSettings$reflection()]], [["ErrorValue", string_type]]])]))], ["getPlans", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [Students_StudentPlans$reflection()]))], ["create", lambda_type(Students_StudentCreateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["updateSettings", lambda_type(Students_StudentUpdateSettingsRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["updatePlan", lambda_type(Students_StudentUpdatePlanRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["updateChatText", lambda_type(Students_StudentUpdateChatTextRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["delete", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["getStudentExternalTeachers", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Students_TeacherListItem$reflection())]))], ["listExternalStudents", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Students_StudentListItem$reflection())]))], ["addExternalTeacher", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["deleteExternalTeacher", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))]]);
}

export class Teachers_TeacherSettings extends Record {
    constructor(Id, Email, FullName) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.FullName = FullName;
    }
}

export function Teachers_TeacherSettings$reflection() {
    return record_type("Shared.Teachers.TeacherSettings", [], Teachers_TeacherSettings, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["FullName", string_type]]);
}

export function Teachers_TeacherSettings_Default() {
    return new Teachers_TeacherSettings(UserIdModule_fromGuid(newGuid()), EmailModule_empty, "New trainer");
}

export class Teachers_TeacherCreateRequest extends Record {
    constructor(Id, Email, Password, FullName) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.Password = Password;
        this.FullName = FullName;
    }
}

export function Teachers_TeacherCreateRequest$reflection() {
    return record_type("Shared.Teachers.TeacherCreateRequest", [], Teachers_TeacherCreateRequest, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["Password", string_type], ["FullName", string_type]]);
}

export class Teachers_TeacherUpdateSettingsRequest extends Record {
    constructor(Id, Email, Password, FullName) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.Password = Password;
        this.FullName = FullName;
    }
}

export function Teachers_TeacherUpdateSettingsRequest$reflection() {
    return record_type("Shared.Teachers.TeacherUpdateSettingsRequest", [], Teachers_TeacherUpdateSettingsRequest, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["Password", string_type], ["FullName", string_type]]);
}

export class Teachers_TeachersApi extends Record {
    constructor(list, getSettings, getTeacherByEmail, create, updateSettings, delete$) {
        super();
        this.list = list;
        this.getSettings = getSettings;
        this.getTeacherByEmail = getTeacherByEmail;
        this.create = create;
        this.updateSettings = updateSettings;
        this.delete = delete$;
    }
}

export function Teachers_TeachersApi$reflection() {
    return record_type("Shared.Teachers.TeachersApi", [], Teachers_TeachersApi, () => [["list", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Students_TeacherListItem$reflection())]))], ["getSettings", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Teachers_TeacherSettings$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", Teachers_TeacherSettings$reflection()]], [["ErrorValue", string_type]]])]))], ["getTeacherByEmail", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [option_type(Students_TeacherListItem$reflection())]))], ["create", lambda_type(Teachers_TeacherCreateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["updateSettings", lambda_type(Teachers_TeacherUpdateSettingsRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["delete", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))]]);
}

export class Admin_Favorite extends Record {
    constructor(Id, Title, UserIds) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.UserIds = UserIds;
    }
}

export function Admin_Favorite$reflection() {
    return record_type("Shared.Admin.Favorite", [], Admin_Favorite, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["UserIds", array_type(class_type("System.Guid"))]]);
}

export function Admin_Favorite_AddOrUpdateFavorite(favorite, favorites) {
    const index = tryFindIndex((x) => (x.Id === favorite.Id), favorites);
    if (index == null) {
        return append(favorites, [favorite]);
    }
    else {
        return map_2((x_1) => ((x_1.Id === favorite.Id) ? favorite : x_1), favorites);
    }
}

export function Admin_Favorite_DeleteFavorite(favoriteId, favorites) {
    return favorites.filter((x) => (x.Id !== favoriteId));
}

export class Admin_FavoriteCreateRequest extends Record {
    constructor(Id, Title, UserIds) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.UserIds = UserIds;
    }
}

export function Admin_FavoriteCreateRequest$reflection() {
    return record_type("Shared.Admin.FavoriteCreateRequest", [], Admin_FavoriteCreateRequest, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["UserIds", array_type(class_type("System.Guid"))]]);
}

export class Admin_FavoriteUpdateRequest extends Record {
    constructor(Id, Title, UserIds) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.UserIds = UserIds;
    }
}

export function Admin_FavoriteUpdateRequest$reflection() {
    return record_type("Shared.Admin.FavoriteUpdateRequest", [], Admin_FavoriteUpdateRequest, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["UserIds", array_type(class_type("System.Guid"))]]);
}

export class Admin_GroupAdminItem extends Record {
    constructor(Id, Title, SchoolId) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.SchoolId = SchoolId;
    }
}

export function Admin_GroupAdminItem$reflection() {
    return record_type("Shared.Admin.GroupAdminItem", [], Admin_GroupAdminItem, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["SchoolId", class_type("System.Guid")]]);
}

export class Admin_StudentSchool extends Record {
    constructor(Id, Email, FullName, SchoolId, GroupId) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.FullName = FullName;
        this.SchoolId = SchoolId;
        this.GroupId = GroupId;
    }
}

export function Admin_StudentSchool$reflection() {
    return record_type("Shared.Admin.StudentSchool", [], Admin_StudentSchool, () => [["Id", class_type("System.Guid")], ["Email", string_type], ["FullName", string_type], ["SchoolId", class_type("System.Guid")], ["GroupId", class_type("System.Guid")]]);
}

export class Admin_StudentSchoolUpdateRequest extends Record {
    constructor(Id, SchoolId, GroupId) {
        super();
        this.Id = Id;
        this.SchoolId = SchoolId;
        this.GroupId = GroupId;
    }
}

export function Admin_StudentSchoolUpdateRequest$reflection() {
    return record_type("Shared.Admin.StudentSchoolUpdateRequest", [], Admin_StudentSchoolUpdateRequest, () => [["Id", class_type("System.Guid")], ["SchoolId", class_type("System.Guid")], ["GroupId", class_type("System.Guid")]]);
}

export class Admin_FavoritesApi extends Record {
    constructor(favoriteList, updateFavorite, deleteFavorite, addFavoriteUser, deleteFavoriteUser, studentsByIds, getAllGroups, getStudentSchool, updateStudentSchool) {
        super();
        this.favoriteList = favoriteList;
        this.updateFavorite = updateFavorite;
        this.deleteFavorite = deleteFavorite;
        this.addFavoriteUser = addFavoriteUser;
        this.deleteFavoriteUser = deleteFavoriteUser;
        this.studentsByIds = studentsByIds;
        this.getAllGroups = getAllGroups;
        this.getStudentSchool = getStudentSchool;
        this.updateStudentSchool = updateStudentSchool;
    }
}

export function Admin_FavoritesApi$reflection() {
    return record_type("Shared.Admin.FavoritesApi", [], Admin_FavoritesApi, () => [["favoriteList", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [array_type(Admin_Favorite$reflection())]))], ["updateFavorite", lambda_type(Admin_FavoriteUpdateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["deleteFavorite", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["addFavoriteUser", lambda_type(tuple_type(class_type("System.Guid"), class_type("System.Guid")), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["deleteFavoriteUser", lambda_type(tuple_type(class_type("System.Guid"), class_type("System.Guid")), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["studentsByIds", lambda_type(list_type(class_type("System.Guid")), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Students_StudentListItem$reflection())]))], ["getAllGroups", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Admin_GroupAdminItem$reflection())]))], ["getStudentSchool", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [Admin_StudentSchool$reflection()]))], ["updateStudentSchool", lambda_type(Admin_StudentSchoolUpdateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))]]);
}

export class EnduranceIntensity_EnduranceIntensity extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Aerob1", "Aerob2", "Aerob3Minus", "Aerob3", "Aerob3Plus", "Competition"];
    }
}

export function EnduranceIntensity_EnduranceIntensity$reflection() {
    return union_type("Shared.EnduranceIntensity.EnduranceIntensity", [], EnduranceIntensity_EnduranceIntensity, () => [[], [], [], [], [], []]);
}

export const EnduranceIntensity_list = ofArray([new EnduranceIntensity_EnduranceIntensity(0), new EnduranceIntensity_EnduranceIntensity(1), new EnduranceIntensity_EnduranceIntensity(2), new EnduranceIntensity_EnduranceIntensity(3), new EnduranceIntensity_EnduranceIntensity(4), new EnduranceIntensity_EnduranceIntensity(5)]);

export function EnduranceIntensity_parseEnduranceIntensityStr(_arg1) {
    switch (_arg1) {
        case "Aerob1": {
            return new EnduranceIntensity_EnduranceIntensity(0);
        }
        case "Aerob2": {
            return new EnduranceIntensity_EnduranceIntensity(1);
        }
        case "Aerob3Minus": {
            return new EnduranceIntensity_EnduranceIntensity(2);
        }
        case "Aerob3": {
            return new EnduranceIntensity_EnduranceIntensity(3);
        }
        case "Aerob3Plus": {
            return new EnduranceIntensity_EnduranceIntensity(4);
        }
        case "Competition": {
            return new EnduranceIntensity_EnduranceIntensity(5);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong endurance intensity string! %s%P()", [_arg1]))));
        }
    }
}

export function EnduranceIntensity_strEnduranceIntensity(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "Aerob 2";
        }
        case 2: {
            return "Aerob 3-";
        }
        case 3: {
            return "Aerob 3";
        }
        case 4: {
            return "Aerob 3+";
        }
        case 5: {
            return "Tävling";
        }
        default: {
            return "Aerob 1";
        }
    }
}

export function EnduranceIntensity_getEnduranceIntensityColor(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "#ffcc00";
        }
        case 2: {
            return "#ff9900";
        }
        case 3: {
            return "#ff6600";
        }
        case 4: {
            return "#ff6600";
        }
        case 5: {
            return "#ff6600";
        }
        default: {
            return "#ffff00";
        }
    }
}

export function EnduranceIntensity_parseEnduranceIntensityCode(_arg1) {
    switch (_arg1) {
        case 0: {
            return new EnduranceIntensity_EnduranceIntensity(0);
        }
        case 1: {
            return new EnduranceIntensity_EnduranceIntensity(1);
        }
        case 2: {
            return new EnduranceIntensity_EnduranceIntensity(3);
        }
        case 3: {
            return new EnduranceIntensity_EnduranceIntensity(5);
        }
        case 4: {
            return new EnduranceIntensity_EnduranceIntensity(2);
        }
        case 5: {
            return new EnduranceIntensity_EnduranceIntensity(4);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong endurance intensity code! %i%P()", [_arg1]))));
        }
    }
}

export class EnduranceActivity_EnduranceActivity extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Running", "Orientation", "RollerSkisClassic", "RollerSkisFree", "SkisClassic", "SkisFree", "Skiing", "UpperBody", "Bike", "OtherTraining"];
    }
}

export function EnduranceActivity_EnduranceActivity$reflection() {
    return union_type("Shared.EnduranceActivity.EnduranceActivity", [], EnduranceActivity_EnduranceActivity, () => [[], [], [], [], [], [], [], [], [], []]);
}

export const EnduranceActivity_list = ofArray([new EnduranceActivity_EnduranceActivity(0), new EnduranceActivity_EnduranceActivity(1), new EnduranceActivity_EnduranceActivity(2), new EnduranceActivity_EnduranceActivity(3), new EnduranceActivity_EnduranceActivity(4), new EnduranceActivity_EnduranceActivity(5), new EnduranceActivity_EnduranceActivity(6), new EnduranceActivity_EnduranceActivity(7), new EnduranceActivity_EnduranceActivity(8), new EnduranceActivity_EnduranceActivity(9)]);

export function EnduranceActivity_parseEnduranceActivityStr(_arg1) {
    switch (_arg1) {
        case "Running": {
            return new EnduranceActivity_EnduranceActivity(0);
        }
        case "RollerSkisClassic": {
            return new EnduranceActivity_EnduranceActivity(2);
        }
        case "RollerSkisFree": {
            return new EnduranceActivity_EnduranceActivity(3);
        }
        case "SkisClassic": {
            return new EnduranceActivity_EnduranceActivity(4);
        }
        case "SkisFree": {
            return new EnduranceActivity_EnduranceActivity(5);
        }
        case "Bike": {
            return new EnduranceActivity_EnduranceActivity(8);
        }
        case "Orientation": {
            return new EnduranceActivity_EnduranceActivity(1);
        }
        case "Skiing": {
            return new EnduranceActivity_EnduranceActivity(6);
        }
        case "UpperBody": {
            return new EnduranceActivity_EnduranceActivity(7);
        }
        case "OtherTraining": {
            return new EnduranceActivity_EnduranceActivity(9);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong endurance activity string! %s%P()", [_arg1]))));
        }
    }
}

export function EnduranceActivity_strEnduranceActivity(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "Orientering";
        }
        case 2: {
            return "Rullskidor Klassiskt";
        }
        case 3: {
            return "Rullskidor Fri";
        }
        case 4: {
            return "Skidor Klassiskt";
        }
        case 5: {
            return "Skidor Fri";
        }
        case 6: {
            return "Skidgång";
        }
        case 7: {
            return "Överkropp";
        }
        case 8: {
            return "Cykel";
        }
        case 9: {
            return "Övrig Träning";
        }
        default: {
            return "Löpning";
        }
    }
}

export function EnduranceActivity_getEnduranceActivityColor(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "#ffa500";
        }
        case 2: {
            return "#ff0000";
        }
        case 3: {
            return "#f08080";
        }
        case 4: {
            return "#00008b";
        }
        case 5: {
            return "#add8e6";
        }
        case 6: {
            return "#006400";
        }
        case 7: {
            return "#90ee90";
        }
        case 8: {
            return "#a52a2a";
        }
        case 9: {
            return "#800080";
        }
        default: {
            return "#ffff00";
        }
    }
}

export function EnduranceActivity_parseEnduranceActivityCode(_arg1) {
    switch (_arg1) {
        case 0: {
            return new EnduranceActivity_EnduranceActivity(0);
        }
        case 1: {
            return new EnduranceActivity_EnduranceActivity(2);
        }
        case 2: {
            return new EnduranceActivity_EnduranceActivity(3);
        }
        case 3: {
            return new EnduranceActivity_EnduranceActivity(4);
        }
        case 4: {
            return new EnduranceActivity_EnduranceActivity(5);
        }
        case 5: {
            return new EnduranceActivity_EnduranceActivity(8);
        }
        case 6: {
            return new EnduranceActivity_EnduranceActivity(1);
        }
        case 7: {
            return new EnduranceActivity_EnduranceActivity(6);
        }
        case 8: {
            return new EnduranceActivity_EnduranceActivity(7);
        }
        case 9: {
            return new EnduranceActivity_EnduranceActivity(9);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong endurance activity code! %i%P()", [_arg1]))));
        }
    }
}

export class StrengthActivity_StrengthActivity extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["StrengthOverall", "StrengthSpecific", "StrengthMax"];
    }
}

export function StrengthActivity_StrengthActivity$reflection() {
    return union_type("Shared.StrengthActivity.StrengthActivity", [], StrengthActivity_StrengthActivity, () => [[], [], []]);
}

export const StrengthActivity_list = ofArray([new StrengthActivity_StrengthActivity(0), new StrengthActivity_StrengthActivity(1), new StrengthActivity_StrengthActivity(2)]);

export function StrengthActivity_parseStrengthActivityStr(_arg1) {
    switch (_arg1) {
        case "StrengthOverall": {
            return new StrengthActivity_StrengthActivity(0);
        }
        case "StrengthSpecific": {
            return new StrengthActivity_StrengthActivity(1);
        }
        case "StrengthMax": {
            return new StrengthActivity_StrengthActivity(2);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong strength activity string! %s%P()", [_arg1]))));
        }
    }
}

export function StrengthActivity_strStrengthActivity(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "Styrka specifik";
        }
        case 2: {
            return "Styrka max";
        }
        default: {
            return "Styrka allmän";
        }
    }
}

export function StrengthActivity_getStrengthActivityColor(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "#333333";
        }
        case 2: {
            return "#000000";
        }
        default: {
            return "#666666";
        }
    }
}

export function StrengthActivity_parseStrengthActivityCode(_arg1) {
    switch (_arg1) {
        case 0: {
            return new StrengthActivity_StrengthActivity(0);
        }
        case 1: {
            return new StrengthActivity_StrengthActivity(1);
        }
        case 2: {
            return new StrengthActivity_StrengthActivity(2);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong strength activity code! %i%P()", [_arg1]))));
        }
    }
}

export class SpeedActivity_SpeedActivity extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["LongImpulses", "ShortImpulses", "RiseRace"];
    }
}

export function SpeedActivity_SpeedActivity$reflection() {
    return union_type("Shared.SpeedActivity.SpeedActivity", [], SpeedActivity_SpeedActivity, () => [[], [], []]);
}

export const SpeedActivity_list = ofArray([new SpeedActivity_SpeedActivity(0), new SpeedActivity_SpeedActivity(1), new SpeedActivity_SpeedActivity(2)]);

export function SpeedActivity_parseSpeedActivityStr(_arg1) {
    switch (_arg1) {
        case "LongImpulses": {
            return new SpeedActivity_SpeedActivity(0);
        }
        case "ShortImpulses": {
            return new SpeedActivity_SpeedActivity(1);
        }
        case "RiseRace": {
            return new SpeedActivity_SpeedActivity(2);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong speed activity string! %s%P()", [_arg1]))));
        }
    }
}

export function SpeedActivity_strSpeedActivity(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "Korta impulser";
        }
        case 2: {
            return "Stegringslopp";
        }
        default: {
            return "Långa impulser";
        }
    }
}

export function SpeedActivity_getSpeedActivityColor(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "#0066ff";
        }
        case 2: {
            return "#00ccff";
        }
        default: {
            return "#0000ff";
        }
    }
}

export function SpeedActivity_parseSpeedActivityCode(_arg1) {
    switch (_arg1) {
        case 0: {
            return new SpeedActivity_SpeedActivity(0);
        }
        case 1: {
            return new SpeedActivity_SpeedActivity(1);
        }
        case 2: {
            return new SpeedActivity_SpeedActivity(2);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong speed activity code! %i%P()", [_arg1]))));
        }
    }
}

export class WorkoutType_EnduranceInfo extends Record {
    constructor(Activity, Intensity, Duration) {
        super();
        this.Activity = Activity;
        this.Intensity = Intensity;
        this.Duration = (Duration | 0);
    }
}

export function WorkoutType_EnduranceInfo$reflection() {
    return record_type("Shared.WorkoutType.EnduranceInfo", [], WorkoutType_EnduranceInfo, () => [["Activity", EnduranceActivity_EnduranceActivity$reflection()], ["Intensity", EnduranceIntensity_EnduranceIntensity$reflection()], ["Duration", int32_type]]);
}

export function WorkoutType_EnduranceInfo_get_Default() {
    return new WorkoutType_EnduranceInfo(new EnduranceActivity_EnduranceActivity(0), new EnduranceIntensity_EnduranceIntensity(0), DurationModule_fromInt(0));
}

export class WorkoutType_StrengthInfo extends Record {
    constructor(Activity, Duration) {
        super();
        this.Activity = Activity;
        this.Duration = (Duration | 0);
    }
}

export function WorkoutType_StrengthInfo$reflection() {
    return record_type("Shared.WorkoutType.StrengthInfo", [], WorkoutType_StrengthInfo, () => [["Activity", StrengthActivity_StrengthActivity$reflection()], ["Duration", int32_type]]);
}

export function WorkoutType_StrengthInfo_get_Default() {
    return new WorkoutType_StrengthInfo(new StrengthActivity_StrengthActivity(0), DurationModule_fromInt(0));
}

export class WorkoutType_MobilityInfo extends Record {
    constructor(Duration) {
        super();
        this.Duration = (Duration | 0);
    }
}

export function WorkoutType_MobilityInfo$reflection() {
    return record_type("Shared.WorkoutType.MobilityInfo", [], WorkoutType_MobilityInfo, () => [["Duration", int32_type]]);
}

export function WorkoutType_MobilityInfo_get_Default() {
    return new WorkoutType_MobilityInfo(DurationModule_fromInt(0));
}

export class WorkoutType_SpeedInfo extends Record {
    constructor(Activity, Amount) {
        super();
        this.Activity = Activity;
        this.Amount = (Amount | 0);
    }
}

export function WorkoutType_SpeedInfo$reflection() {
    return record_type("Shared.WorkoutType.SpeedInfo", [], WorkoutType_SpeedInfo, () => [["Activity", SpeedActivity_SpeedActivity$reflection()], ["Amount", int32_type]]);
}

export function WorkoutType_SpeedInfo_get_Default() {
    return new WorkoutType_SpeedInfo(new SpeedActivity_SpeedActivity(0), 0);
}

export class WorkoutType_WorkoutType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Endurance", "Strength", "Mobility", "Speed", "Rest"];
    }
}

export function WorkoutType_WorkoutType$reflection() {
    return union_type("Shared.WorkoutType.WorkoutType", [], WorkoutType_WorkoutType, () => [[["Item", WorkoutType_EnduranceInfo$reflection()]], [["Item", WorkoutType_StrengthInfo$reflection()]], [["Item", WorkoutType_MobilityInfo$reflection()]], [["Item", WorkoutType_SpeedInfo$reflection()]], []]);
}

export function WorkoutType_WorkoutType_get_MobilityDefaultColor() {
    return "#cccccc";
}

export function WorkoutType_WorkoutType_get_RestDefaultColor() {
    return "#00ff00";
}

export function WorkoutType_getWorkoutTypeTotalDuration(workoutType) {
    switch (workoutType.tag) {
        case 1: {
            return workoutType.fields[0].Duration | 0;
        }
        case 2: {
            return workoutType.fields[0].Duration | 0;
        }
        case 3:
        case 4: {
            return DurationModule_fromInt(0) | 0;
        }
        default: {
            return workoutType.fields[0].Duration | 0;
        }
    }
}

export function WorkoutType_getWorkoutTypeColor(workoutType) {
    switch (workoutType.tag) {
        case 1: {
            return StrengthActivity_getStrengthActivityColor(workoutType.fields[0].Activity);
        }
        case 2: {
            return WorkoutType_WorkoutType_get_MobilityDefaultColor();
        }
        case 3: {
            return SpeedActivity_getSpeedActivityColor(workoutType.fields[0].Activity);
        }
        case 4: {
            return WorkoutType_WorkoutType_get_RestDefaultColor();
        }
        default: {
            return EnduranceIntensity_getEnduranceIntensityColor(workoutType.fields[0].Intensity);
        }
    }
}

export function WorkoutType_strWorkoutType(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "Styrka";
        }
        case 2: {
            return "Rörlighet";
        }
        case 3: {
            return "Snabbhet";
        }
        case 4: {
            return "Vila";
        }
        default: {
            return "Uthållighet";
        }
    }
}

export function WorkoutType_titleWorkoutType(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return StrengthActivity_strStrengthActivity(_arg1.fields[0].Activity);
        }
        case 2: {
            return WorkoutType_strWorkoutType(new WorkoutType_WorkoutType(2, WorkoutType_MobilityInfo_get_Default()));
        }
        case 3: {
            return SpeedActivity_strSpeedActivity(_arg1.fields[0].Activity);
        }
        case 4: {
            return WorkoutType_strWorkoutType(new WorkoutType_WorkoutType(4));
        }
        default: {
            return EnduranceActivity_strEnduranceActivity(_arg1.fields[0].Activity);
        }
    }
}

export class Workout_WorkoutPart extends Record {
    constructor(IsPrimary, WorkoutType) {
        super();
        this.IsPrimary = IsPrimary;
        this.WorkoutType = WorkoutType;
    }
}

export function Workout_WorkoutPart$reflection() {
    return record_type("Shared.Workout.WorkoutPart", [], Workout_WorkoutPart, () => [["IsPrimary", bool_type], ["WorkoutType", WorkoutType_WorkoutType$reflection()]]);
}

export function Workout_getWorkoutPartTotalDuration(workoutPart) {
    return WorkoutType_getWorkoutTypeTotalDuration(workoutPart.WorkoutType);
}

export function Workout_getWorkoutPartColor(workoutPart) {
    return WorkoutType_getWorkoutTypeColor(workoutPart.WorkoutType);
}

export class Workout_Workout extends Record {
    constructor(Title, Comment$, WorkoutParts) {
        super();
        this.Title = Title;
        this.Comment = Comment$;
        this.WorkoutParts = WorkoutParts;
    }
}

export function Workout_Workout$reflection() {
    return record_type("Shared.Workout.Workout", [], Workout_Workout, () => [["Title", string_type], ["Comment", string_type], ["WorkoutParts", array_type(Workout_WorkoutPart$reflection())]]);
}

export function Workout_Workout_get_Default() {
    return new Workout_Workout("", "", []);
}

export function Workout_Workout_get_DefaultColor() {
    return "#339966";
}

export function Workout_getWorkoutTotalDurationSec(workout) {
    return sum(map_2((x) => DurationModule_toInt(Workout_getWorkoutPartTotalDuration(x)), workout.WorkoutParts, Int32Array), {
        GetZero: () => 0,
        Add: (x_2, y) => (x_2 + y),
    });
}

export function Workout_getWorkoutTotalDuration(workout) {
    return DurationModule_fromInt(Workout_getWorkoutTotalDurationSec(workout));
}

export function Workout_getWorkoutColor(workout) {
    return defaultArg(map_1((x_1) => Workout_getWorkoutPartColor(x_1), defaultArg(tryFind((x) => x.IsPrimary, workout.WorkoutParts), tryHead(workout.WorkoutParts))), Workout_Workout_get_DefaultColor());
}

export class WorkoutTemplates_WorkoutTemplateInfo extends Record {
    constructor(Id, IsGlobal, Workout) {
        super();
        this.Id = Id;
        this.IsGlobal = IsGlobal;
        this.Workout = Workout;
    }
}

export function WorkoutTemplates_WorkoutTemplateInfo$reflection() {
    return record_type("Shared.WorkoutTemplates.WorkoutTemplateInfo", [], WorkoutTemplates_WorkoutTemplateInfo, () => [["Id", class_type("System.Guid")], ["IsGlobal", bool_type], ["Workout", Workout_Workout$reflection()]]);
}

export function WorkoutTemplates_WorkoutTemplateInfo_get_Default() {
    return new WorkoutTemplates_WorkoutTemplateInfo(WorkoutTemplateIdModule_fromGuid(newGuid()), false, Workout_Workout_get_Default());
}

export class WorkoutTemplates_WorkoutTemplatesApi extends Record {
    constructor(listUser, listSchool, get$, create, update, delete$) {
        super();
        this.listUser = listUser;
        this.listSchool = listSchool;
        this.get = get$;
        this.create = create;
        this.update = update;
        this.delete = delete$;
    }
}

export function WorkoutTemplates_WorkoutTemplatesApi$reflection() {
    return record_type("Shared.WorkoutTemplates.WorkoutTemplatesApi", [], WorkoutTemplates_WorkoutTemplatesApi, () => [["listUser", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(WorkoutTemplates_WorkoutTemplateInfo$reflection())]))], ["listSchool", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(WorkoutTemplates_WorkoutTemplateInfo$reflection())]))], ["get", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [WorkoutTemplates_WorkoutTemplateInfo$reflection()]))], ["create", lambda_type(WorkoutTemplates_WorkoutTemplateInfo$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["update", lambda_type(WorkoutTemplates_WorkoutTemplateInfo$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["delete", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))]]);
}

export class DaySegment_DaySegment extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Mo", "Fm", "Em", "Kv"];
    }
}

export function DaySegment_DaySegment$reflection() {
    return union_type("Shared.DaySegment.DaySegment", [], DaySegment_DaySegment, () => [[], [], [], []]);
}

export function DaySegment_isLatestDaySegment(x) {
    return equals(x, new DaySegment_DaySegment(3));
}

export const DaySegment_list = ofArray([new DaySegment_DaySegment(0), new DaySegment_DaySegment(1), new DaySegment_DaySegment(2), new DaySegment_DaySegment(3)]);

export function DaySegment_strDaySegment(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "Fm.";
        }
        case 2: {
            return "Em.";
        }
        case 3: {
            return "Kv.";
        }
        default: {
            return "Mo.";
        }
    }
}

export function DaySegment_parseDaySegment(_arg1) {
    switch (_arg1) {
        case 0: {
            return new DaySegment_DaySegment(0);
        }
        case 1: {
            return new DaySegment_DaySegment(1);
        }
        case 2: {
            return new DaySegment_DaySegment(2);
        }
        case 3: {
            return new DaySegment_DaySegment(3);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong day segment code! %i%P()", [_arg1]))));
        }
    }
}

export class Shape_Shape extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ExtremelyLight", "VeryVeryLight", "VeryLight", "Light", "OK", "LitleHeavy", "VeryHeavy", "VeryVeryHeavy", "ExtremelyHeavy"];
    }
}

export function Shape_Shape$reflection() {
    return union_type("Shared.Shape.Shape", [], Shape_Shape, () => [[], [], [], [], [], [], [], [], []]);
}

export const Shape_list = ofArray([new Shape_Shape(0), new Shape_Shape(1), new Shape_Shape(2), new Shape_Shape(3), new Shape_Shape(4), new Shape_Shape(5), new Shape_Shape(6), new Shape_Shape(7), new Shape_Shape(8)]);

export function Shape_parseShapeStr(_arg1) {
    switch (_arg1) {
        case "ExtremelyLight": {
            return new Shape_Shape(0);
        }
        case "VeryVeryLight": {
            return new Shape_Shape(1);
        }
        case "VeryLight": {
            return new Shape_Shape(2);
        }
        case "Light": {
            return new Shape_Shape(3);
        }
        case "OK": {
            return new Shape_Shape(4);
        }
        case "LitleHeavy": {
            return new Shape_Shape(5);
        }
        case "VeryHeavy": {
            return new Shape_Shape(6);
        }
        case "VeryVeryHeavy": {
            return new Shape_Shape(7);
        }
        case "ExtremelyHeavy": {
            return new Shape_Shape(8);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong shape string! %s%P()", [_arg1]))));
        }
    }
}

export function Shape_strShape(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "+3 Mycket mycket lätt";
        }
        case 2: {
            return "+2 Mycket lätt";
        }
        case 3: {
            return "+1 Lätt/pigg";
        }
        case 4: {
            return "0 OK";
        }
        case 5: {
            return "-1 Lite tungt";
        }
        case 6: {
            return "-2 Mycket tungt";
        }
        case 7: {
            return "-3 Mycket mycket tungt";
        }
        case 8: {
            return "-4 Extremt tungt";
        }
        default: {
            return "+4 Extremt lätt";
        }
    }
}

export function Shape_getShapeIntValue(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return 3;
        }
        case 2: {
            return 2;
        }
        case 3: {
            return 1;
        }
        case 4: {
            return 0;
        }
        case 5: {
            return -1;
        }
        case 6: {
            return -2;
        }
        case 7: {
            return -3;
        }
        case 8: {
            return -4;
        }
        default: {
            return 4;
        }
    }
}

export function Shape_parseShape(_arg1) {
    switch (_arg1) {
        case 0: {
            return new Shape_Shape(0);
        }
        case 1: {
            return new Shape_Shape(1);
        }
        case 2: {
            return new Shape_Shape(2);
        }
        case 3: {
            return new Shape_Shape(3);
        }
        case 4: {
            return new Shape_Shape(4);
        }
        case 5: {
            return new Shape_Shape(5);
        }
        case 6: {
            return new Shape_Shape(6);
        }
        case 7: {
            return new Shape_Shape(7);
        }
        case 8: {
            return new Shape_Shape(8);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong shape code! %i%P()", [_arg1]))));
        }
    }
}

export class DayPlan_DayPlan extends Record {
    constructor(DaySegment, Workout) {
        super();
        this.DaySegment = DaySegment;
        this.Workout = Workout;
    }
}

export function DayPlan_DayPlan$reflection() {
    return record_type("Shared.DayPlan.DayPlan", [], DayPlan_DayPlan, () => [["DaySegment", DaySegment_DaySegment$reflection()], ["Workout", Workout_Workout$reflection()]]);
}

export class DayFact_DayFact extends Record {
    constructor(DaySegment, Shape, CommentAfterTraining, Workout) {
        super();
        this.DaySegment = DaySegment;
        this.Shape = Shape;
        this.CommentAfterTraining = CommentAfterTraining;
        this.Workout = Workout;
    }
}

export function DayFact_DayFact$reflection() {
    return record_type("Shared.DayFact.DayFact", [], DayFact_DayFact, () => [["DaySegment", DaySegment_DaySegment$reflection()], ["Shape", Shape_Shape$reflection()], ["CommentAfterTraining", string_type], ["Workout", Workout_Workout$reflection()]]);
}

export function DayFact_DayFact_Default_Z38742B54(daySegment) {
    return new DayFact_DayFact(daySegment, new Shape_Shape(4), "", Workout_Workout_get_Default());
}

export function DayFact_createFromDayPlan(dayPlan) {
    return new DayFact_DayFact(dayPlan.DaySegment, new Shape_Shape(4), "", dayPlan.Workout);
}

export class DayPlanFact_DayPlanFact extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Plan", "Fact"];
    }
}

export function DayPlanFact_DayPlanFact$reflection() {
    return union_type("Shared.DayPlanFact.DayPlanFact", [], DayPlanFact_DayPlanFact, () => [[["Item", DayPlan_DayPlan$reflection()]], [["Item", DayFact_DayFact$reflection()]]]);
}

export class SleepQuality_SleepQuality extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["HardToSleep", "RestlessSleep", "OkSleep", "GoodSleep", "DeepSleep"];
    }
}

export function SleepQuality_SleepQuality$reflection() {
    return union_type("Shared.SleepQuality.SleepQuality", [], SleepQuality_SleepQuality, () => [[], [], [], [], []]);
}

export const SleepQuality_list = ofArray([new SleepQuality_SleepQuality(0), new SleepQuality_SleepQuality(1), new SleepQuality_SleepQuality(2), new SleepQuality_SleepQuality(3), new SleepQuality_SleepQuality(4)]);

export function SleepQuality_getSleepQualityCode(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return -1;
        }
        case 2: {
            return 0;
        }
        case 3: {
            return 1;
        }
        case 4: {
            return 2;
        }
        default: {
            return -2;
        }
    }
}

export function SleepQuality_strSleepQuality(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "Orolig sömn";
        }
        case 2: {
            return "OK Sömn";
        }
        case 3: {
            return "God sömn";
        }
        case 4: {
            return "Djupsömn";
        }
        default: {
            return "Svårt att sova";
        }
    }
}

export function SleepQuality_displaySleepQuality(x) {
    return toText(interpolate("%P() %P()", [SleepQuality_getSleepQualityCode(x), SleepQuality_strSleepQuality(x)]));
}

export function SleepQuality_parseSleepQualityStr(_arg1) {
    switch (_arg1) {
        case "HardToSleep": {
            return new SleepQuality_SleepQuality(0);
        }
        case "RestlessSleep": {
            return new SleepQuality_SleepQuality(1);
        }
        case "OkSleep": {
            return new SleepQuality_SleepQuality(2);
        }
        case "GoodSleep": {
            return new SleepQuality_SleepQuality(3);
        }
        case "DeepSleep": {
            return new SleepQuality_SleepQuality(4);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong sleep quality string! %s%P()", [_arg1]))));
        }
    }
}

export function SleepQuality_parseSleepQuality(_arg1) {
    switch (_arg1) {
        case -2: {
            return new SleepQuality_SleepQuality(0);
        }
        case -1: {
            return new SleepQuality_SleepQuality(1);
        }
        case 0: {
            return new SleepQuality_SleepQuality(2);
        }
        case 1: {
            return new SleepQuality_SleepQuality(3);
        }
        case 2: {
            return new SleepQuality_SleepQuality(4);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong sleep quality code! %i%P()", [_arg1]))));
        }
    }
}

export class Menstruation_Menstruation extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NoMenstruation", "MenstruationStarted", "MenstruationCompleted"];
    }
}

export function Menstruation_Menstruation$reflection() {
    return union_type("Shared.Menstruation.Menstruation", [], Menstruation_Menstruation, () => [[], [], []]);
}

export const Menstruation_list = ofArray([new Menstruation_Menstruation(0), new Menstruation_Menstruation(1), new Menstruation_Menstruation(2)]);

export function Menstruation_getMenstruationCode(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return 2;
        }
        case 2: {
            return 3;
        }
        default: {
            return 1;
        }
    }
}

export function Menstruation_strMenstruation(_arg1) {
    switch (_arg1.tag) {
        case 1: {
            return "Menstruation påbörjad";
        }
        case 2: {
            return "Menstruation avslutad";
        }
        default: {
            return "Ingen menstruation";
        }
    }
}

export function Menstruation_displayMenstruation(x) {
    return toText(interpolate("%P() %P()", [Menstruation_getMenstruationCode(x), Menstruation_strMenstruation(x)]));
}

export function Menstruation_parseMenstruationStr(_arg1) {
    switch (_arg1) {
        case "NoMenstruation": {
            return new Menstruation_Menstruation(0);
        }
        case "MenstruationStarted": {
            return new Menstruation_Menstruation(1);
        }
        case "MenstruationCompleted": {
            return new Menstruation_Menstruation(2);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong menstruation string! %s%P()", [_arg1]))));
        }
    }
}

export function Menstruation_parseMenstruation(_arg1) {
    switch (_arg1) {
        case 1: {
            return new Menstruation_Menstruation(0);
        }
        case 2: {
            return new Menstruation_Menstruation(1);
        }
        case 3: {
            return new Menstruation_Menstruation(2);
        }
        default: {
            throw (new Error(toText(interpolate("Wrong menstruation code! %i%P()", [_arg1]))));
        }
    }
}

export class DayData_DayData extends Record {
    constructor(IsSick, IsDamaged, IsTravelDay, Heartrate, Sleep, SleepQuality, Menstruation) {
        super();
        this.IsSick = IsSick;
        this.IsDamaged = IsDamaged;
        this.IsTravelDay = IsTravelDay;
        this.Heartrate = (Heartrate | 0);
        this.Sleep = (Sleep | 0);
        this.SleepQuality = SleepQuality;
        this.Menstruation = Menstruation;
    }
}

export function DayData_DayData$reflection() {
    return record_type("Shared.DayData.DayData", [], DayData_DayData, () => [["IsSick", bool_type], ["IsDamaged", bool_type], ["IsTravelDay", bool_type], ["Heartrate", int32_type], ["Sleep", int32_type], ["SleepQuality", SleepQuality_SleepQuality$reflection()], ["Menstruation", Menstruation_Menstruation$reflection()]]);
}

export function DayData_DayData_get_Default() {
    return new DayData_DayData(false, false, false, 0, 1, new SleepQuality_SleepQuality(2), new Menstruation_Menstruation(0));
}

export class PlanFact_PlanFact extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Plan", "Fact"];
    }
}

export function PlanFact_PlanFact$reflection() {
    return union_type("Shared.PlanFact.PlanFact", [], PlanFact_PlanFact, () => [[], []]);
}

export const PlanFact_list = ofArray([new PlanFact_PlanFact(0), new PlanFact_PlanFact(1)]);

export function PlanFact_strPlanFact(_arg1) {
    if (_arg1.tag === 1) {
        return "Genomfört";
    }
    else {
        return "Planering";
    }
}

export class DragType_DayPlanFactDrop extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Plan", "Fact", "WorkoutTemplate"];
    }
}

export function DragType_DayPlanFactDrop$reflection() {
    return union_type("Shared.DragType.DayPlanFactDrop", [], DragType_DayPlanFactDrop, () => [[["Item", DayPlan_DayPlan$reflection()]], [["Item", DayFact_DayFact$reflection()]], [["Item", WorkoutTemplates_WorkoutTemplateInfo$reflection()]]]);
}

export function DayHelpers_withDaySegment(daySegment, dayPlanFact) {
    if (dayPlanFact.tag === 1) {
        const fact = dayPlanFact.fields[0];
        return new DayPlanFact_DayPlanFact(1, new DayFact_DayFact(daySegment, fact.Shape, fact.CommentAfterTraining, fact.Workout));
    }
    else {
        return new DayPlanFact_DayPlanFact(0, new DayPlan_DayPlan(daySegment, dayPlanFact.fields[0].Workout));
    }
}

export function DayHelpers_tryFindPlan(daySegment, dayPlans) {
    return tryFind((x) => equals(x.DaySegment, daySegment), dayPlans);
}

export function DayHelpers_tryFindFact(daySegment, dayFacts) {
    return tryFind((x) => equals(x.DaySegment, daySegment), dayFacts);
}

export function DayHelpers_tryFindPlanFact(dayPlans, dayFacts, planFact, daySegment) {
    if (planFact.tag === 1) {
        return map_1((arg0_1) => (new DayPlanFact_DayPlanFact(1, arg0_1)), DayHelpers_tryFindFact(daySegment, dayFacts));
    }
    else {
        return map_1((arg0) => (new DayPlanFact_DayPlanFact(0, arg0)), DayHelpers_tryFindPlan(daySegment, dayPlans));
    }
}

export function DayHelpers_deletePlan(daySegment, dayPlans) {
    return dayPlans.filter((d) => (!equals(d.DaySegment, daySegment)));
}

export function DayHelpers_deleteFact(daySegment, dayFacts) {
    return dayFacts.filter((d) => (!equals(d.DaySegment, daySegment)));
}

export function DayHelpers_deletePlanFact(daySegment, planFact, dayPlans, dayFacts) {
    if (planFact.tag === 1) {
        return [dayPlans, DayHelpers_deleteFact(daySegment, dayFacts)];
    }
    else {
        return [DayHelpers_deletePlan(daySegment, dayPlans), dayFacts];
    }
}

export function DayHelpers_addUpdatePlan(dayPlan, dayPlans) {
    const matchValue = DayHelpers_tryFindPlan(dayPlan.DaySegment, dayPlans);
    if (matchValue == null) {
        return append(dayPlans, [dayPlan]);
    }
    else {
        return map_2((d) => (equals(d.DaySegment, dayPlan.DaySegment) ? dayPlan : d), dayPlans);
    }
}

export function DayHelpers_addUpdateFact(dayFact, dayFacts) {
    const matchValue = DayHelpers_tryFindFact(dayFact.DaySegment, dayFacts);
    if (matchValue == null) {
        return append(dayFacts, [dayFact]);
    }
    else {
        return map_2((d) => (equals(d.DaySegment, dayFact.DaySegment) ? dayFact : d), dayFacts);
    }
}

export function DayHelpers_addUpdatePlanFact(dayPlanFact, dayPlans, dayFacts) {
    if (dayPlanFact.tag === 1) {
        return [dayPlans, DayHelpers_addUpdateFact(dayPlanFact.fields[0], dayFacts)];
    }
    else {
        return [DayHelpers_addUpdatePlan(dayPlanFact.fields[0], dayPlans), dayFacts];
    }
}

export function DayHelpers_appendDayPlans(dayPlans, originalDayPlans) {
    const originalSegments = map_3((x) => x.DaySegment, originalDayPlans);
    return Array.from(choose((daySegment) => {
        let originalDayPlan, inputRecord;
        const matchValue = [DayHelpers_tryFindPlan(daySegment, originalDayPlans), DayHelpers_tryFindPlan(daySegment, dayPlans)];
        if (matchValue[0] == null) {
            if (matchValue[1] == null) {
                return void 0;
            }
            else {
                const dayPlan_2 = matchValue[1];
                return dayPlan_2;
            }
        }
        else if (matchValue[1] != null) {
            const dayPlan_3 = matchValue[1];
            const originalDayPlan_3 = matchValue[0];
            return originalDayPlan = originalDayPlan_3, new DayPlan_DayPlan(originalDayPlan.DaySegment, (inputRecord = originalDayPlan.Workout, new Workout_Workout(inputRecord.Title, inputRecord.Comment, append(originalDayPlan.Workout.WorkoutParts, dayPlan_3.Workout.WorkoutParts))));
        }
        else {
            const originalDayPlan_2 = matchValue[0];
            return originalDayPlan_2;
        }
    }, distinct(append_1(map_3((x_1) => x_1.DaySegment, dayPlans), originalSegments), {
        Equals: (x_2, y) => equals(x_2, y),
        GetHashCode: (x_2) => safeHash(x_2),
    })));
}

export class ScheduleDay_ScheduleDay extends Record {
    constructor(WeekDay, DayPlans) {
        super();
        this.WeekDay = (WeekDay | 0);
        this.DayPlans = DayPlans;
    }
}

export function ScheduleDay_ScheduleDay$reflection() {
    return record_type("Shared.ScheduleDay.ScheduleDay", [], ScheduleDay_ScheduleDay, () => [["WeekDay", int32_type], ["DayPlans", array_type(DayPlan_DayPlan$reflection())]]);
}

export function ScheduleDay_ScheduleDay_Default_Z524259A4(weekDay) {
    return new ScheduleDay_ScheduleDay(weekDay, []);
}

export class ScheduleWeek_ScheduleWeek extends Record {
    constructor(PeriodWeek, ScheduleDays) {
        super();
        this.PeriodWeek = (PeriodWeek | 0);
        this.ScheduleDays = ScheduleDays;
    }
}

export function ScheduleWeek_ScheduleWeek$reflection() {
    return record_type("Shared.ScheduleWeek.ScheduleWeek", [], ScheduleWeek_ScheduleWeek, () => [["PeriodWeek", int32_type], ["ScheduleDays", array_type(ScheduleDay_ScheduleDay$reflection())]]);
}

export function ScheduleWeek_ScheduleWeek_Default_Z524259A4(periodWeek) {
    return new ScheduleWeek_ScheduleWeek(periodWeek, []);
}

export class StudentDays_StudentDayKey extends Record {
    constructor(StudentId, CalendarDay) {
        super();
        this.StudentId = StudentId;
        this.CalendarDay = CalendarDay;
    }
}

export function StudentDays_StudentDayKey$reflection() {
    return record_type("Shared.StudentDays.StudentDayKey", [], StudentDays_StudentDayKey, () => [["StudentId", class_type("System.Guid")], ["CalendarDay", CalendarDay_CalendarDay$reflection()]]);
}

export class StudentDays_StudentDayInfo extends Record {
    constructor(StudentId, CalendarDay, DayPlans, DayFacts, DayData) {
        super();
        this.StudentId = StudentId;
        this.CalendarDay = CalendarDay;
        this.DayPlans = DayPlans;
        this.DayFacts = DayFacts;
        this.DayData = DayData;
    }
}

export function StudentDays_StudentDayInfo$reflection() {
    return record_type("Shared.StudentDays.StudentDayInfo", [], StudentDays_StudentDayInfo, () => [["StudentId", class_type("System.Guid")], ["CalendarDay", CalendarDay_CalendarDay$reflection()], ["DayPlans", array_type(DayPlan_DayPlan$reflection())], ["DayFacts", array_type(DayFact_DayFact$reflection())], ["DayData", option_type(DayData_DayData$reflection())]]);
}

export function StudentDays_StudentDayInfo_Empty(studentId, calendarDay) {
    return new StudentDays_StudentDayInfo(studentId, calendarDay, [], [], void 0);
}

export class StudentDays_StudentDayListRequest extends Record {
    constructor(StudentId, Year, Period, Week, WeekDay) {
        super();
        this.StudentId = StudentId;
        this.Year = (Year | 0);
        this.Period = (Period | 0);
        this.Week = Week;
        this.WeekDay = WeekDay;
    }
}

export function StudentDays_StudentDayListRequest$reflection() {
    return record_type("Shared.StudentDays.StudentDayListRequest", [], StudentDays_StudentDayListRequest, () => [["StudentId", class_type("System.Guid")], ["Year", int32_type], ["Period", int32_type], ["Week", option_type(int32_type)], ["WeekDay", option_type(int32_type)]]);
}

export class StudentDays_StudentDayUpdatePlanFactRequest extends Record {
    constructor(StudentId, CalendarDay, DayPlanFact) {
        super();
        this.StudentId = StudentId;
        this.CalendarDay = CalendarDay;
        this.DayPlanFact = DayPlanFact;
    }
}

export function StudentDays_StudentDayUpdatePlanFactRequest$reflection() {
    return record_type("Shared.StudentDays.StudentDayUpdatePlanFactRequest", [], StudentDays_StudentDayUpdatePlanFactRequest, () => [["StudentId", class_type("System.Guid")], ["CalendarDay", CalendarDay_CalendarDay$reflection()], ["DayPlanFact", DayPlanFact_DayPlanFact$reflection()]]);
}

export class StudentDays_StudentDayMovePlanFactRequest extends Record {
    constructor(StudentId, CalendarDayTo, DaySegmentTo, CalendarDayFrom, DaySegmentFrom, PlanFact) {
        super();
        this.StudentId = StudentId;
        this.CalendarDayTo = CalendarDayTo;
        this.DaySegmentTo = DaySegmentTo;
        this.CalendarDayFrom = CalendarDayFrom;
        this.DaySegmentFrom = DaySegmentFrom;
        this.PlanFact = PlanFact;
    }
}

export function StudentDays_StudentDayMovePlanFactRequest$reflection() {
    return record_type("Shared.StudentDays.StudentDayMovePlanFactRequest", [], StudentDays_StudentDayMovePlanFactRequest, () => [["StudentId", class_type("System.Guid")], ["CalendarDayTo", CalendarDay_CalendarDay$reflection()], ["DaySegmentTo", DaySegment_DaySegment$reflection()], ["CalendarDayFrom", CalendarDay_CalendarDay$reflection()], ["DaySegmentFrom", DaySegment_DaySegment$reflection()], ["PlanFact", PlanFact_PlanFact$reflection()]]);
}

export class StudentDays_StudentDayDeletePlanFactRequest extends Record {
    constructor(StudentId, CalendarDay, DaySegment, PlanFact) {
        super();
        this.StudentId = StudentId;
        this.CalendarDay = CalendarDay;
        this.DaySegment = DaySegment;
        this.PlanFact = PlanFact;
    }
}

export function StudentDays_StudentDayDeletePlanFactRequest$reflection() {
    return record_type("Shared.StudentDays.StudentDayDeletePlanFactRequest", [], StudentDays_StudentDayDeletePlanFactRequest, () => [["StudentId", class_type("System.Guid")], ["CalendarDay", CalendarDay_CalendarDay$reflection()], ["DaySegment", DaySegment_DaySegment$reflection()], ["PlanFact", PlanFact_PlanFact$reflection()]]);
}

export class StudentDays_StudentDayImplementPlanRequest extends Record {
    constructor(StudentId, CalendarDay, DayFact) {
        super();
        this.StudentId = StudentId;
        this.CalendarDay = CalendarDay;
        this.DayFact = DayFact;
    }
}

export function StudentDays_StudentDayImplementPlanRequest$reflection() {
    return record_type("Shared.StudentDays.StudentDayImplementPlanRequest", [], StudentDays_StudentDayImplementPlanRequest, () => [["StudentId", class_type("System.Guid")], ["CalendarDay", CalendarDay_CalendarDay$reflection()], ["DayFact", DayFact_DayFact$reflection()]]);
}

export class StudentDays_StudentDayUpdateDataRequest extends Record {
    constructor(StudentId, CalendarDay, DayData) {
        super();
        this.StudentId = StudentId;
        this.CalendarDay = CalendarDay;
        this.DayData = DayData;
    }
}

export function StudentDays_StudentDayUpdateDataRequest$reflection() {
    return record_type("Shared.StudentDays.StudentDayUpdateDataRequest", [], StudentDays_StudentDayUpdateDataRequest, () => [["StudentId", class_type("System.Guid")], ["CalendarDay", CalendarDay_CalendarDay$reflection()], ["DayData", DayData_DayData$reflection()]]);
}

export class StudentDays_ScheduleAssignMode extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Add", "Append", "Overwrite"];
    }
}

export function StudentDays_ScheduleAssignMode$reflection() {
    return union_type("Shared.StudentDays.ScheduleAssignMode", [], StudentDays_ScheduleAssignMode, () => [[], [], []]);
}

export class StudentDays_ScheduleAssignRequest extends Record {
    constructor(ScheduleId, StudentIds, Period, ScheduleWeeks, ScheduleAssignMode) {
        super();
        this.ScheduleId = ScheduleId;
        this.StudentIds = StudentIds;
        this.Period = Period;
        this.ScheduleWeeks = ScheduleWeeks;
        this.ScheduleAssignMode = ScheduleAssignMode;
    }
}

export function StudentDays_ScheduleAssignRequest$reflection() {
    return record_type("Shared.StudentDays.ScheduleAssignRequest", [], StudentDays_ScheduleAssignRequest, () => [["ScheduleId", class_type("System.Guid")], ["StudentIds", list_type(class_type("System.Guid"))], ["Period", Calendar_PeriodInfo$reflection()], ["ScheduleWeeks", array_type(ScheduleWeek_ScheduleWeek$reflection())], ["ScheduleAssignMode", StudentDays_ScheduleAssignMode$reflection()]]);
}

export class StudentDays_StudentDaysApi extends Record {
    constructor(list, create, updatePlanFact, movePlanFact, deletePlanFact, implementPlan, updateData, assign) {
        super();
        this.list = list;
        this.create = create;
        this.updatePlanFact = updatePlanFact;
        this.movePlanFact = movePlanFact;
        this.deletePlanFact = deletePlanFact;
        this.implementPlan = implementPlan;
        this.updateData = updateData;
        this.assign = assign;
    }
}

export function StudentDays_StudentDaysApi$reflection() {
    return record_type("Shared.StudentDays.StudentDaysApi", [], StudentDays_StudentDaysApi, () => [["list", lambda_type(StudentDays_StudentDayListRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(StudentDays_StudentDayInfo$reflection())]))], ["create", lambda_type(StudentDays_StudentDayInfo$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["updatePlanFact", lambda_type(StudentDays_StudentDayUpdatePlanFactRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["movePlanFact", lambda_type(StudentDays_StudentDayMovePlanFactRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, tuple_type(string_type, option_type(string_type))], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", tuple_type(string_type, option_type(string_type))]]])]))], ["deletePlanFact", lambda_type(StudentDays_StudentDayDeletePlanFactRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["implementPlan", lambda_type(StudentDays_StudentDayImplementPlanRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, tuple_type(string_type, option_type(string_type))], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", tuple_type(string_type, option_type(string_type))]]])]))], ["updateData", lambda_type(StudentDays_StudentDayUpdateDataRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["assign", lambda_type(StudentDays_ScheduleAssignRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))]]);
}

export function ScheduleHelpers_addUpdateScheduleDayPlan(dayPlan, scheduleDay) {
    return new ScheduleDay_ScheduleDay(scheduleDay.WeekDay, DayHelpers_addUpdatePlan(dayPlan, scheduleDay.DayPlans));
}

export function ScheduleHelpers_deleteScheduleDayPlan(daySegment, scheduleDay) {
    return new ScheduleDay_ScheduleDay(scheduleDay.WeekDay, DayHelpers_deletePlan(daySegment, scheduleDay.DayPlans));
}

export function ScheduleHelpers_tryFindScheduleDay(weekDay, scheduleDays) {
    return tryFind((x) => (x.WeekDay === weekDay), scheduleDays);
}

export function ScheduleHelpers_updateScheduleDays(weekDay, f, scheduleDays) {
    return map_2((x) => {
        if (x.WeekDay === weekDay) {
            return f(x);
        }
        else {
            return x;
        }
    }, scheduleDays);
}

export function ScheduleHelpers_addUpdateScheduleDaysPlan(weekDay, dayPlan, scheduleDays) {
    const matchValue = ScheduleHelpers_tryFindScheduleDay(weekDay, scheduleDays);
    if (matchValue == null) {
        return append(scheduleDays, [ScheduleHelpers_addUpdateScheduleDayPlan(dayPlan, ScheduleDay_ScheduleDay_Default_Z524259A4(weekDay))]);
    }
    else {
        return ScheduleHelpers_updateScheduleDays(weekDay, (scheduleDay) => ScheduleHelpers_addUpdateScheduleDayPlan(dayPlan, scheduleDay), scheduleDays);
    }
}

export function ScheduleHelpers_deleteScheduleDaysPlan(weekDay, daySegment, scheduleDays) {
    return ScheduleHelpers_updateScheduleDays(weekDay, (scheduleDay) => ScheduleHelpers_deleteScheduleDayPlan(daySegment, scheduleDay), scheduleDays);
}

export function ScheduleHelpers_addUpdateScheduleWeekPlan(weekDay, dayPlan, scheduleWeek) {
    return new ScheduleWeek_ScheduleWeek(scheduleWeek.PeriodWeek, ScheduleHelpers_addUpdateScheduleDaysPlan(weekDay, dayPlan, scheduleWeek.ScheduleDays));
}

export function ScheduleHelpers_deleteScheduleWeekPlan(weekDay, daySegment, scheduleWeek) {
    return new ScheduleWeek_ScheduleWeek(scheduleWeek.PeriodWeek, ScheduleHelpers_deleteScheduleDaysPlan(weekDay, daySegment, scheduleWeek.ScheduleDays));
}

export function ScheduleHelpers_tryFindScheduleWeek(periodWeek, scheduleWeeks) {
    return tryFind((x) => (x.PeriodWeek === periodWeek), scheduleWeeks);
}

export function ScheduleHelpers_updateScheduleWeeks(periodWeek, f, scheduleWeeks) {
    return map_2((x) => {
        if (x.PeriodWeek === periodWeek) {
            return f(x);
        }
        else {
            return x;
        }
    }, scheduleWeeks);
}

export function ScheduleHelpers_addUpdateScheduleWeeksPlan(periodWeek, weekDay, dayPlan, scheduleWeeks) {
    const matchValue = ScheduleHelpers_tryFindScheduleWeek(periodWeek, scheduleWeeks);
    if (matchValue == null) {
        return append(scheduleWeeks, [ScheduleHelpers_addUpdateScheduleWeekPlan(weekDay, dayPlan, ScheduleWeek_ScheduleWeek_Default_Z524259A4(periodWeek))]);
    }
    else {
        return ScheduleHelpers_updateScheduleWeeks(periodWeek, (scheduleWeek) => ScheduleHelpers_addUpdateScheduleWeekPlan(weekDay, dayPlan, scheduleWeek), scheduleWeeks);
    }
}

export function ScheduleHelpers_deleteScheduleWeeksPlan(periodWeek, weekDay, daySegment, scheduleWeeks) {
    return ScheduleHelpers_updateScheduleWeeks(periodWeek, (scheduleWeek) => ScheduleHelpers_deleteScheduleWeekPlan(weekDay, daySegment, scheduleWeek), scheduleWeeks);
}

export function ScheduleHelpers_tryFindScheduleWeeksDayPlan(periodWeek, weekDay, daySegment, scheduleWeeks) {
    return bind((dayPlans) => DayHelpers_tryFindPlan(daySegment, dayPlans), map_1((x_1) => x_1.DayPlans, bind((scheduleDays) => ScheduleHelpers_tryFindScheduleDay(weekDay, scheduleDays), map_1((x) => x.ScheduleDays, ScheduleHelpers_tryFindScheduleWeek(periodWeek, scheduleWeeks)))));
}

export class Schedules_ScheduleDayKey extends Record {
    constructor(ScheduleId, PeriodWeek, WeekDay) {
        super();
        this.ScheduleId = ScheduleId;
        this.PeriodWeek = (PeriodWeek | 0);
        this.WeekDay = (WeekDay | 0);
    }
}

export function Schedules_ScheduleDayKey$reflection() {
    return record_type("Shared.Schedules.ScheduleDayKey", [], Schedules_ScheduleDayKey, () => [["ScheduleId", class_type("System.Guid")], ["PeriodWeek", int32_type], ["WeekDay", int32_type]]);
}

export class Schedules_ScheduleInfo extends Record {
    constructor(Id, TeacherId, Title, IsGlobal, ScheduleWeeks) {
        super();
        this.Id = Id;
        this.TeacherId = TeacherId;
        this.Title = Title;
        this.IsGlobal = IsGlobal;
        this.ScheduleWeeks = ScheduleWeeks;
    }
}

export function Schedules_ScheduleInfo$reflection() {
    return record_type("Shared.Schedules.ScheduleInfo", [], Schedules_ScheduleInfo, () => [["Id", class_type("System.Guid")], ["TeacherId", class_type("System.Guid")], ["Title", string_type], ["IsGlobal", bool_type], ["ScheduleWeeks", array_type(ScheduleWeek_ScheduleWeek$reflection())]]);
}

export function Schedules_ScheduleInfo_Default_Z1043BF58(teacherId) {
    return new Schedules_ScheduleInfo(ScheduleIdModule_fromGuid(newGuid()), teacherId, "", false, []);
}

export class Schedules_ScheduleListItem extends Record {
    constructor(Id, TeacherId, Title, IsGlobal) {
        super();
        this.Id = Id;
        this.TeacherId = TeacherId;
        this.Title = Title;
        this.IsGlobal = IsGlobal;
    }
}

export function Schedules_ScheduleListItem$reflection() {
    return record_type("Shared.Schedules.ScheduleListItem", [], Schedules_ScheduleListItem, () => [["Id", class_type("System.Guid")], ["TeacherId", class_type("System.Guid")], ["Title", string_type], ["IsGlobal", bool_type]]);
}

export function Schedules_ScheduleListItem_Default_Z1043BF58(teacherId) {
    return new Schedules_ScheduleListItem(ScheduleIdModule_fromGuid(newGuid()), teacherId, "", false);
}

export class Schedules_ScheduleCreateRequest extends Record {
    constructor(Id, Title, IsGlobal, ScheduleWeeks) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.IsGlobal = IsGlobal;
        this.ScheduleWeeks = ScheduleWeeks;
    }
}

export function Schedules_ScheduleCreateRequest$reflection() {
    return record_type("Shared.Schedules.ScheduleCreateRequest", [], Schedules_ScheduleCreateRequest, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["IsGlobal", bool_type], ["ScheduleWeeks", array_type(ScheduleWeek_ScheduleWeek$reflection())]]);
}

export class Schedules_ScheduleCreateAsDuplicateRequest extends Record {
    constructor(Id, Title, IsGlobal, ScheduleWeeks, SourceScheduleId) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.IsGlobal = IsGlobal;
        this.ScheduleWeeks = ScheduleWeeks;
        this.SourceScheduleId = SourceScheduleId;
    }
}

export function Schedules_ScheduleCreateAsDuplicateRequest$reflection() {
    return record_type("Shared.Schedules.ScheduleCreateAsDuplicateRequest", [], Schedules_ScheduleCreateAsDuplicateRequest, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["IsGlobal", bool_type], ["ScheduleWeeks", array_type(ScheduleWeek_ScheduleWeek$reflection())], ["SourceScheduleId", class_type("System.Guid")]]);
}

export class Schedules_ScheduleUpdateRequest extends Record {
    constructor(Id, Title, IsGlobal, ScheduleWeeks) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.IsGlobal = IsGlobal;
        this.ScheduleWeeks = ScheduleWeeks;
    }
}

export function Schedules_ScheduleUpdateRequest$reflection() {
    return record_type("Shared.Schedules.ScheduleUpdateRequest", [], Schedules_ScheduleUpdateRequest, () => [["Id", class_type("System.Guid")], ["Title", string_type], ["IsGlobal", bool_type], ["ScheduleWeeks", option_type(array_type(ScheduleWeek_ScheduleWeek$reflection()))]]);
}

export class Schedules_ScheduleUpdatePlanRequest extends Record {
    constructor(Id, PeriodWeek, WeekDay, DayPlan) {
        super();
        this.Id = Id;
        this.PeriodWeek = (PeriodWeek | 0);
        this.WeekDay = (WeekDay | 0);
        this.DayPlan = DayPlan;
    }
}

export function Schedules_ScheduleUpdatePlanRequest$reflection() {
    return record_type("Shared.Schedules.ScheduleUpdatePlanRequest", [], Schedules_ScheduleUpdatePlanRequest, () => [["Id", class_type("System.Guid")], ["PeriodWeek", int32_type], ["WeekDay", int32_type], ["DayPlan", DayPlan_DayPlan$reflection()]]);
}

export class Schedules_ScheduleMovePlanRequest extends Record {
    constructor(Id, PeriodWeekTo, WeekDayTo, DaySegmentTo, PeriodWeekFrom, WeekDayFrom, DaySegmentFrom) {
        super();
        this.Id = Id;
        this.PeriodWeekTo = (PeriodWeekTo | 0);
        this.WeekDayTo = (WeekDayTo | 0);
        this.DaySegmentTo = DaySegmentTo;
        this.PeriodWeekFrom = (PeriodWeekFrom | 0);
        this.WeekDayFrom = (WeekDayFrom | 0);
        this.DaySegmentFrom = DaySegmentFrom;
    }
}

export function Schedules_ScheduleMovePlanRequest$reflection() {
    return record_type("Shared.Schedules.ScheduleMovePlanRequest", [], Schedules_ScheduleMovePlanRequest, () => [["Id", class_type("System.Guid")], ["PeriodWeekTo", int32_type], ["WeekDayTo", int32_type], ["DaySegmentTo", DaySegment_DaySegment$reflection()], ["PeriodWeekFrom", int32_type], ["WeekDayFrom", int32_type], ["DaySegmentFrom", DaySegment_DaySegment$reflection()]]);
}

export class Schedules_ScheduleDeletePlanRequest extends Record {
    constructor(Id, PeriodWeek, WeekDay, DaySegment) {
        super();
        this.Id = Id;
        this.PeriodWeek = (PeriodWeek | 0);
        this.WeekDay = (WeekDay | 0);
        this.DaySegment = DaySegment;
    }
}

export function Schedules_ScheduleDeletePlanRequest$reflection() {
    return record_type("Shared.Schedules.ScheduleDeletePlanRequest", [], Schedules_ScheduleDeletePlanRequest, () => [["Id", class_type("System.Guid")], ["PeriodWeek", int32_type], ["WeekDay", int32_type], ["DaySegment", DaySegment_DaySegment$reflection()]]);
}

export class Schedules_SchedulesApi extends Record {
    constructor(list, get$, create, createAsDuplicate, update, updatePlan, movePlan, deletePlan, delete$) {
        super();
        this.list = list;
        this.get = get$;
        this.create = create;
        this.createAsDuplicate = createAsDuplicate;
        this.update = update;
        this.updatePlan = updatePlan;
        this.movePlan = movePlan;
        this.deletePlan = deletePlan;
        this.delete = delete$;
    }
}

export function Schedules_SchedulesApi$reflection() {
    return record_type("Shared.Schedules.SchedulesApi", [], Schedules_SchedulesApi, () => [["list", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Schedules_ScheduleListItem$reflection())]))], ["get", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [Schedules_ScheduleInfo$reflection()]))], ["create", lambda_type(Schedules_ScheduleCreateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["createAsDuplicate", lambda_type(Schedules_ScheduleCreateAsDuplicateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["update", lambda_type(Schedules_ScheduleUpdateRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["updatePlan", lambda_type(Schedules_ScheduleUpdatePlanRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["movePlan", lambda_type(Schedules_ScheduleMovePlanRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["deletePlan", lambda_type(Schedules_ScheduleDeletePlanRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["delete", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))]]);
}

export class Statistics_StatisticType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["School", "Group", "Student"];
    }
}

export function Statistics_StatisticType$reflection() {
    return union_type("Shared.Statistics.StatisticType", [], Statistics_StatisticType, () => [[["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]]]);
}

export class Statistics_StatisticRequest extends Record {
    constructor(StatisticType, DateFrom, DateTo) {
        super();
        this.StatisticType = StatisticType;
        this.DateFrom = DateFrom;
        this.DateTo = DateTo;
    }
}

export function Statistics_StatisticRequest$reflection() {
    return record_type("Shared.Statistics.StatisticRequest", [], Statistics_StatisticRequest, () => [["StatisticType", Statistics_StatisticType$reflection()], ["DateFrom", class_type("System.DateTime")], ["DateTo", class_type("System.DateTime")]]);
}

export const Statistics_StatisticsExportApiBasePath = "/api/statistic-export";

export const Statistics_StatisticsExportXlsxPath = "/xlsx";

export class Statistics_StatisticsApi extends Record {
    constructor(daysList, yearPlanSeconds) {
        super();
        this.daysList = daysList;
        this.yearPlanSeconds = yearPlanSeconds;
    }
}

export function Statistics_StatisticsApi$reflection() {
    return record_type("Shared.Statistics.StatisticsApi", [], Statistics_StatisticsApi, () => [["daysList", lambda_type(Statistics_StatisticRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(StudentDays_StudentDayInfo$reflection())]))], ["yearPlanSeconds", lambda_type(Statistics_StatisticRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [int32_type]))]]);
}

export class Schools_School extends Record {
    constructor(Id, Title) {
        super();
        this.Id = Id;
        this.Title = Title;
    }
}

export function Schools_School$reflection() {
    return record_type("Shared.Schools.School", [], Schools_School, () => [["Id", class_type("System.Guid")], ["Title", string_type]]);
}

export class Schools_SchoolsApi extends Record {
    constructor(list, get$) {
        super();
        this.list = list;
        this.get = get$;
    }
}

export function Schools_SchoolsApi$reflection() {
    return record_type("Shared.Schools.SchoolsApi", [], Schools_SchoolsApi, () => [["list", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Schools_School$reflection())]))], ["get", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [Schools_School$reflection()]))]]);
}

export function StatisticHelpers_folderOpt(sumFunc, accOpt, itemOpt) {
    const matchValue = [accOpt, itemOpt];
    if (matchValue[0] == null) {
        if (matchValue[1] == null) {
            return void 0;
        }
        else {
            return itemOpt;
        }
    }
    else if (matchValue[1] == null) {
        return accOpt;
    }
    else {
        const acc = value_2(matchValue[0]);
        const item = value_2(matchValue[1]);
        return some(sumFunc(acc, item));
    }
}

export function StatisticHelpers_foldDurationOpt(list) {
    return fold((accOpt, itemOpt) => StatisticHelpers_folderOpt((x, y) => (x + y), accOpt, itemOpt), void 0, list);
}

export function StatisticHelpers_calcEnduranceActivityDuration(i, workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    let pattern_matching_result, x_1;
    if (matchValue.tag === 0) {
        if (equals(matchValue.fields[0].Activity, i)) {
            pattern_matching_result = 0;
            x_1 = matchValue.fields[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return DurationModule_toInt(x_1.Duration);
        }
        case 1: {
            return void 0;
        }
    }
}

export function StatisticHelpers_calcEnduranceActivityCount(i, workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    let pattern_matching_result;
    if (matchValue.tag === 0) {
        if (equals(matchValue.fields[0].Activity, i)) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return 1;
        }
        case 1: {
            return void 0;
        }
    }
}

export function StatisticHelpers_calcEnduranceIntensityDuration(i, workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    let pattern_matching_result, x_1;
    if (matchValue.tag === 0) {
        if (equals(matchValue.fields[0].Intensity, i)) {
            pattern_matching_result = 0;
            x_1 = matchValue.fields[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return DurationModule_toInt(x_1.Duration);
        }
        case 1: {
            return void 0;
        }
    }
}

export function StatisticHelpers_calcEnduranceIntensityCount(i, workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    let pattern_matching_result;
    if (matchValue.tag === 0) {
        if (equals(matchValue.fields[0].Intensity, i)) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return 1;
        }
        case 1: {
            return void 0;
        }
    }
}

export function StatisticHelpers_intBool(x) {
    if (x) {
        return 1;
    }
    else {
        return 0;
    }
}

export class StatisticHelpers_StatSummary extends Record {
    constructor(DurationSeconds, Amount, Count, IsPrimaryCount) {
        super();
        this.DurationSeconds = (DurationSeconds | 0);
        this.Amount = (Amount | 0);
        this.Count = (Count | 0);
        this.IsPrimaryCount = (IsPrimaryCount | 0);
    }
}

export function StatisticHelpers_StatSummary$reflection() {
    return record_type("Shared.StatisticHelpers.StatSummary", [], StatisticHelpers_StatSummary, () => [["DurationSeconds", int32_type], ["Amount", int32_type], ["Count", int32_type], ["IsPrimaryCount", int32_type]]);
}

export function StatisticHelpers_createStatSummary(durationSeconds, amount, count, isPrimaryCount) {
    return new StatisticHelpers_StatSummary(durationSeconds, amount, count, isPrimaryCount);
}

export function StatisticHelpers_statSummary(duration, amount, count, isPrimary) {
    return StatisticHelpers_createStatSummary(DurationModule_toInt(duration), amount, count, StatisticHelpers_intBool(isPrimary));
}

export function StatisticHelpers_sumStatSummary(x, y) {
    return StatisticHelpers_createStatSummary(x.DurationSeconds + y.DurationSeconds, x.Amount + y.Amount, x.Count + y.Count, x.IsPrimaryCount + y.IsPrimaryCount);
}

export function StatisticHelpers_calcWorkoutPart(workoutPart) {
    return StatisticHelpers_statSummary(Workout_getWorkoutPartTotalDuration(workoutPart), 0, 1, workoutPart.IsPrimary);
}

export function StatisticHelpers_calcEnduranceIntensity(i, workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    let pattern_matching_result, x_1;
    if (matchValue.tag === 0) {
        if (equals(matchValue.fields[0].Intensity, i)) {
            pattern_matching_result = 0;
            x_1 = matchValue.fields[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return StatisticHelpers_statSummary(x_1.Duration, 0, 1, workoutPart.IsPrimary);
        }
        case 1: {
            return void 0;
        }
    }
}

export function StatisticHelpers_calcEnduranceActivity(i, workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    let pattern_matching_result, x_1;
    if (matchValue.tag === 0) {
        if (equals(matchValue.fields[0].Activity, i)) {
            pattern_matching_result = 0;
            x_1 = matchValue.fields[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return StatisticHelpers_statSummary(x_1.Duration, 0, 1, workoutPart.IsPrimary);
        }
        case 1: {
            return void 0;
        }
    }
}

export function StatisticHelpers_calcStrength(workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    if (matchValue.tag === 1) {
        return StatisticHelpers_statSummary(matchValue.fields[0].Duration, 0, 1, workoutPart.IsPrimary);
    }
    else {
        return void 0;
    }
}

export function StatisticHelpers_calcStrengthActivity(i, workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    let pattern_matching_result, x_1;
    if (matchValue.tag === 1) {
        if (equals(matchValue.fields[0].Activity, i)) {
            pattern_matching_result = 0;
            x_1 = matchValue.fields[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return StatisticHelpers_statSummary(x_1.Duration, 0, 1, workoutPart.IsPrimary);
        }
        case 1: {
            return void 0;
        }
    }
}

export function StatisticHelpers_calcMobility(workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    if (matchValue.tag === 2) {
        return StatisticHelpers_statSummary(matchValue.fields[0].Duration, 0, 1, workoutPart.IsPrimary);
    }
    else {
        return void 0;
    }
}

export function StatisticHelpers_calcSpeed(workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    if (matchValue.tag === 3) {
        return StatisticHelpers_statSummary(DurationModule_empty, matchValue.fields[0].Amount, 1, workoutPart.IsPrimary);
    }
    else {
        return void 0;
    }
}

export function StatisticHelpers_calcSpeedActivity(i, workoutPart) {
    const matchValue = workoutPart.WorkoutType;
    let pattern_matching_result, x_1;
    if (matchValue.tag === 3) {
        if (equals(matchValue.fields[0].Activity, i)) {
            pattern_matching_result = 0;
            x_1 = matchValue.fields[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return StatisticHelpers_statSummary(DurationModule_empty, x_1.Amount, 1, workoutPart.IsPrimary);
        }
        case 1: {
            return void 0;
        }
    }
}

export function StatisticHelpers_calcRest(workoutPart) {
    if (workoutPart.WorkoutType.tag === 4) {
        return StatisticHelpers_statSummary(DurationModule_empty, 1, 1, workoutPart.IsPrimary);
    }
    else {
        return void 0;
    }
}

export function StatisticHelpers_facts(list) {
    return map_3((x_1) => x_1.Workout, collect((x) => x.DayFacts, list));
}

export function StatisticHelpers_plans(list) {
    return map_3((x_1) => x_1.Workout, collect((x) => x.DayPlans, list));
}

export function StatisticHelpers_mapWorkoutParts(f, list) {
    return map_3((x_1) => f(x_1), collect((x) => x.WorkoutParts, list));
}

export function StatisticHelpers_foldStatSummaryOpt(list) {
    return fold((accOpt, itemOpt) => StatisticHelpers_folderOpt((x, y) => StatisticHelpers_sumStatSummary(x, y), accOpt, itemOpt), void 0, list);
}

export function StatisticHelpers_strSummary(summaryOpt) {
    return defaultArg(map_1((summary) => [DurationModule_intToHMSString(summary.DurationSeconds), toText(interpolate("%P() st", [summary.Amount])), int32ToString(summary.IsPrimaryCount)], summaryOpt), ["", "", ""]);
}

export function StatisticHelpers_getSummaryIsPrimaryCount(summaryOpt) {
    return defaultArg(map_1((summary) => summary.IsPrimaryCount, summaryOpt), 0);
}

export function StatisticHelpers_calcPlanSummary(f, list) {
    return StatisticHelpers_foldStatSummaryOpt(StatisticHelpers_mapWorkoutParts(f, StatisticHelpers_plans(list)));
}

export function StatisticHelpers_calcFactSummary(f, list) {
    return StatisticHelpers_foldStatSummaryOpt(StatisticHelpers_mapWorkoutParts(f, StatisticHelpers_facts(list)));
}

export function StatisticHelpers_folded3Sum(x, y, z, s_x, s_y, s_z) {
    return [s_x + x, s_y + y, s_z + z];
}

export function StatisticHelpers_calcDayDataSummary(list) {
    return fold((tupledArg, tupledArg_1) => StatisticHelpers_folded3Sum(tupledArg[0], tupledArg[1], tupledArg[2], tupledArg_1[0], tupledArg_1[1], tupledArg_1[2]), [0, 0, 0], map_3((x_2) => [StatisticHelpers_intBool(x_2.IsSick), StatisticHelpers_intBool(x_2.IsDamaged), StatisticHelpers_intBool(x_2.IsTravelDay)], choose((x_1) => x_1, map_3((x) => x.DayData, list))));
}

export function StatisticHelpers_calcForm(list) {
    const dayForms = ofSeq(map_3((x_3) => ((dayFact) => [Shape_getShapeIntValue(dayFact.Shape), sumBy((x) => {
        if (equals(x.WorkoutType, new WorkoutType_WorkoutType(4))) {
            return 0;
        }
        else {
            return 1;
        }
    }, dayFact.Workout.WorkoutParts, {
        GetZero: () => 0,
        Add: (x_1, y) => (x_1 + y),
    })])(x_3), collect((x_2) => x_2.DayFacts, list)));
    const formSum = sumBy_1((tuple) => tuple[0], dayForms, {
        GetZero: () => 0,
        Add: (x_4, y_1) => (x_4 + y_1),
    }) | 0;
    const formPartsSum = sumBy_1((tuple_1) => tuple_1[1], dayForms, {
        GetZero: () => 0,
        Add: (x_5, y_2) => (x_5 + y_2),
    }) | 0;
    if (formPartsSum === 0) {
        return 0;
    }
    else {
        return round(formSum / formPartsSum, 1);
    }
}

